/*
  Farbwechsel ohne Seitenneuladen
  ================================

  Ein Klick auf einen Farbpunkt der Produktseite lädt sonst eine komplett neue Seite:
  2,5 s bis interaktiv, und die Auswahl von Gestellfarbe und Größe fällt auf den
  Standard zurück, weil es technisch ein anderer Artikel ist. Dieses Skript tauscht
  stattdessen nur den Produktbereich aus und überträgt die getroffene Auswahl.

  GRUNDREGEL: Die Farbpunkte bleiben echte Links. Wir fangen nur den Klick ab, und
  JEDER Fehler führt zur normalen Navigation. Dadurch kann das Skript den Shop nie
  in eine Sackgasse führen — es kann nur schneller sein oder wirkungslos bleiben.

  Zwei Dinge, ohne die es nicht funktioniert (beide gemessen, siehe
  docs/2026-08-19-farbwechsel-ohne-reload.md):

  1. Die Section-ID ist template-spezifisch («template--24506034192765__main»).
     Ein Abruf mit `section_id=main-product` liefert Status 200 und plausibles
     Markup, aber OHNE die Blöcke aus dem Template — also ohne Farbpunkte, ohne
     Fehlermeldung. Deshalb lesen wir die ID immer aus dem vorhandenen Markup.
  2. Farbgeschwister teilen dasselbe Produkt-Template, weshalb unsere Section-ID
     auch für sie gilt. Tut sie es ausnahmsweise nicht, antwortet Shopify mit 404 —
     unser Signal für den Rückfall auf normale Navigation.
*/
(function () {
  'use strict';

  var INFO_PRAEFIX = 'ProductInfo-';
  var SECTION_PRAEFIX = 'MainProduct-';

  /* Laufende Nummer gegen überholende Anfragen: Wer schnell mehrere Farben anklickt,
     löst mehrere Abrufe aus, die in beliebiger Reihenfolge zurückkommen können. Ohne
     diese Sperre konnte eine ältere Antwort eine neuere überschreiben — sichtbar als
     Mischzustand aus zwei Artikeln (fremde Optionsfelder im Kaufbereich). Nur der
     jeweils letzte Wunsch darf einsetzen. */
  var laufendeNummer = 0;

  /* Ereignis-Handler, die beim Nachziehen der Section-Skripte entstanden sind. Sie
     werden vor dem nächsten Durchlauf wieder entfernt, damit sie sich nicht anhäufen
     (siehe `skripteAusfuehren`). */
  var nachgezogeneListener = [];

  /* Pro Seitenaufruf gemerkt: Wer zwischen zwei Farben hin- und herspringt, wartet
     ab dem zweiten Mal gar nicht mehr. Schlüssel ist die jeweilige Abruf-URL.

     Begrenzt, weil ein Produktbereich rund 450 KB wiegt: Bei 15 Farbpunkten kämen
     sonst mehrere Megabyte zusammen, die bis zum Verlassen der Seite liegen bleiben.
     Zehn Einträge decken jedes realistische Hin und Her ab; darüber fällt der
     jeweils älteste heraus (Map behält die Einfügereihenfolge). */
  /* 2026-09-18: 15 statt 10 — je Farbe kommt der Abruf des Judge.me-Review-Widgets
     hinzu (rund 6 KB, fällt gegen die 450 KB des Produktbereichs nicht ins Gewicht). */
  /* 2026-10-01: 20 statt 15 — das Vorladen im Leerlauf (vorladenImLeerlauf) legt bis zu
     drei Farben ab, je rund vier Einträge; ein Klick auf eine vierte Farbe soll sie nicht
     gleich wieder verdrängen. */
  /* 2026-10-07: 100 statt 20 — es werden jetzt ALLE Farben vorgeladen (VORLADEN_MAX 20), je rund fünf Einträge
     (Section, .js, .json ×2, Bewertungs-Section). Text im Speicher: ~330 KB je Farbe, bei 15 Farben ~5 MB. */
  var SPEICHER_MAX = 100;
  var speicher = new Map();

  function merken(schluessel, wert) {
    speicher.set(schluessel, wert);
    while (speicher.size > SPEICHER_MAX) {
      speicher.delete(speicher.keys().next().value);
    }
  }

  function sectionId() {
    var info = document.querySelector('product-info[id^="' + INFO_PRAEFIX + '"]');
    return info ? info.id.slice(INFO_PRAEFIX.length) : null;
  }

  /* Judge.me-Review-Widget «Kundenbewertungen» (2026-09-18).

     Das Widget ist ein App-Block in einer EIGENEN Section (Typ «apps») am Seitenende —
     ausserhalb von MainProduct, dem einzigen Bereich, den dieser Wechsel bisher holte
     und ersetzte. Es blieb deshalb auf dem vorherigen Artikel stehen, während das
     Preview-Badge der Kaufbox (liegt IN der Hauptsection) korrekt mitwechselte.

     Lösung: Die Section des Widgets wird für den Zielartikel über dieselbe Section
     Rendering API geholt (gemessen: ihr Markup ist identisch mit dem des vollständigen
     Seitenaufrufs) und ersetzt die vorhandene komplett. Die Section-ID ist wie bei der
     Hauptsection template-spezifisch und wird aus dem vorhandenen Markup gelesen. */
  /* Material-Section (2026-10-03): Seit TELDRA Pro auf EINER Vorlage läuft, kommt der Text zur
     Tischplatte (Melamin/Furnier/Linoleum) aus Produkt-Metafeldern in der Multirow-Section
     «multirow_G6QqTP» — ausserhalb von MainProduct. Sie muss beim Farbwechsel mit, sonst stünde
     nach Furnier → Anthrazit weiter der Furnier-Text (live gemessen 2026-10-03). Hier die
     Suffixe der Section-IDs, die mitgeholt und komplett ersetzt werden; fehlt eine Section
     auf der Seite, wird sie übergangen. Scheitert ihr Abruf, wird normal navigiert. */
  var ZUSATZ_SECTIONS = ['multirow_G6QqTP'];

  function zusatzSections() {
    var liste = [];
    ZUSATZ_SECTIONS.forEach(function (suffix) {
      var el = document.querySelector('.shopify-section[id$="__' + suffix + '"]');
      if (el && !el.querySelector('[id^="' + SECTION_PRAEFIX + '"]')) liste.push(el);
    });
    return liste;
  }

  var JDGM_WIDGET = '.jdgm-widget.jdgm-review-widget';

  function bewertungsSection() {
    var widget = document.querySelector(JDGM_WIDGET);
    var section = widget && widget.closest ? widget.closest('.shopify-section[id^="shopify-section-"]') : null;
    /* Liegt das Widget wider Erwarten in der Hauptsection, wechselt es ohnehin mit. */
    if (!section || section.querySelector('[id^="' + SECTION_PRAEFIX + '"]')) return null;
    return section;
  }

  /* Judge.me rendert das Widget in der «Revamp»-Fassung über ein ES-Modul, das nur beim
     Seitenstart läuft und sich nicht erneut anstossen lässt. Dann navigiert der
     Farbwechsel normal — lieber ein Reload als Bewertungen des falschen Artikels.

     2026-09-30: Der Schalter jdgmSettings.review_widget_revamp_enabled ist seit der
     Judge.me-Einrichtung vom 29.09. AN, und der Farbwechsel lud seither immer die ganze
     Seite. Der Schalter allein entscheidet aber nicht: Judge.mes loader.js (judgeme-770,
     gelesen am 2026-09-30) lädt die Revamp-Fassung nur, wenn
       Schalter an UND (Revamp-Daten jdgm.data.reviewWidget[<Produkt-ID>].reviews
                        vorhanden ODER KEIN klassischer Inhalt im Widget),
     sonst blendet er die klassische .jdgm-legacy-widget-content ein. Im Shop liefert der
     Server heute nur den klassischen Inhalt und keine Revamp-Daten — es läuft also das
     klassische Widget, das sich wie bisher tauschen lässt. Gesperrt wird deshalb nur
     noch, wenn Judge.me auf DIESER Seite tatsächlich die Revamp-Fassung geladen hat
     (gleiche Regel wie der Loader, plus Revamp-Markup oder -Skript im Dokument). Ändert
     Judge.me das Verhalten, greift wieder die normale Navigation. */
  function wbRevampAktiv() {
    var einstellungen = window.jdgmSettings;
    if (!einstellungen || !einstellungen.review_widget_revamp_enabled) return false;
    var widget = document.querySelector(JDGM_WIDGET);
    if (!widget) return false;
    var jdgm = window.jdgm;
    var daten = jdgm && jdgm.data && jdgm.data.reviewWidget;
    var id = widget.getAttribute('data-product-id') || widget.getAttribute('data-id');
    if (daten && id && daten[id] && daten[id].reviews !== undefined) return true;
    var legacy = widget.querySelector('.jdgm-legacy-widget-content');
    if (!legacy || legacy.innerHTML.trim().length <= 20) return true;
    if (legacy.style.display === 'none') return true;
    if (widget.classList.contains('jdgm-widget-revamp') || widget.querySelector('.jdgm-widget-revamp')) return true;
    var modul = widget.getAttribute('data-entry-point');
    if (modul && jdgm && jdgm.CDN_BASE_URL && document.querySelector('script[src="' + jdgm.CDN_BASE_URL + modul + '"]')) return true;
    return false;
  }

  function bewertungenNichtTauschbar() {
    return wbRevampAktiv();
  }

  /* Getauscht wird NUR über den am 2026-09-18 getesteten Legacy-Pfad. Das Widget-Markup
     muss dafür (a) die serverseitige `.jdgm-legacy-widget-content` mit `.jdgm-rev-widg`
     enthalten und (b) frei von <script> sein: Per Section Rendering nachgeladene Skripte
     führt der Browser nicht aus, und wir führen sie bewusst nicht von Hand aus (kein
     eval). Gemessen: Die Antwort enthält heute KEIN Skript und kein
     `jdgm.data.reviewWidget[...]` — dieser Datensatz gehört zur Revamp-Fassung. Taucht
     er (oder irgendein Skript) künftig auf, wäre das Widget nach dem Tausch nur halb
     funktionsfähig → dann normale Navigation. */
  function istLegacyWidget(wurzel) {
    if (!wurzel) return false;
    if (wurzel.querySelector('script')) return false;
    var widget = wurzel.querySelector(JDGM_WIDGET);
    if (!widget) return false;
    var legacy = widget.querySelector('.jdgm-legacy-widget-content');
    return !!(legacy && legacy.querySelector('.jdgm-rev-widg'));
  }

  /* Läuft Judge.me auf dieser Seite? Massgeblich ist das vorhandene Widget: Trägt es
     `jdgm--done-setup-widget`, hat Judge.me es eingerichtet — dann MUSS auch das neue
     eingerichtet werden können, sonst wird gar nicht erst getauscht. Trägt es die Klasse
     nicht (Skript blockiert oder noch nicht geladen), entspricht das eingesetzte
     Server-Markup exakt dem Zustand eines normalen Seitenaufrufs; lädt Judge.me später,
     richtet es das dann vorhandene Widget selbst ein. */
  function jdgmLaeuft() {
    var widget = document.querySelector(JDGM_WIDGET);
    return !!(widget && widget.classList.contains('jdgm--done-setup-widget'));
  }

  function jdgmEinrichtbar() {
    var jdgm = window.jdgm;
    return !!(
      jdgm &&
      typeof jdgm.initializeWidgets === 'function' &&
      typeof jdgm.loadScript === 'function' &&
      typeof jdgm.$ === 'function' &&
      typeof jdgm.getWidgetPrefix === 'function' &&
      jdgm.CDN_HOST
    );
  }

  /* Template des Artikels («» = Standard-Template) aus /products/<handle>.json.

     Nötig, weil der Statuscode KEIN Signal ist (gemessen 2026-09-18, anders als im Kopf
     dieser Datei angenommen): Die Section Rendering API beantwortet unsere Section-ID
     auch für einen Artikel mit anderem product.*.json-Template mit 200 und rendert die
     Section des AKTUELLEN Templates mit den Daten des Zielartikels. Für das
     Bewertungs-Widget hiesse das: Es käme ein Widget, das so auf der Zielseite gar nicht
     steht. Bei abweichendem oder unbekanntem Template wird deshalb normal navigiert —
     Section-IDs werden weder geraten noch umgeschrieben. */
  function vorlageHolen(pfad) {
    return holenJson(pfad + '.json')
      .then(function (antwort) {
        if (!antwort || !antwort.product || !('template_suffix' in antwort.product)) return null;
        return antwort.product.template_suffix || '';
      })
      .catch(function () {
        return null;
      });
  }

  /* pCon-Produkte bleiben aussen vor: Dort hängt ein Konfigurator-iframe am Artikel,
     dessen Verhalten beim Austausch ungeklärt ist. Lieber normal navigieren. */
  function istPconSeite(sid) {
    return !!document.getElementById('KonfiguratorModal-' + sid);
  }

  /* Die aktuelle Auswahl als Zuordnung Optionsname → Wert.
     Über den Namen, nie über die Position: Die Farbartikel führen dieselben Werte
     in unterschiedlicher Reihenfolge. */
  function auswahlLesen() {
    var auswahl = {};
    document.querySelectorAll('variant-selects [data-option-name]').forEach(function (feld) {
      var name = feld.dataset.optionName;
      if (!name) return;
      var select = feld.querySelector('select');
      if (select) {
        auswahl[name] = select.value;
        return;
      }
      var radio = feld.querySelector('input[type="radio"]:checked');
      if (radio) auswahl[name] = radio.value;
    });
    return auswahl;
  }

  /* Die Variante des Zielartikels, die zur bisherigen Auswahl passt.
     «Default» wird übersprungen: Das ist die Hauptvariante (das Parent) aus
     plentymarkets, die über den Sync als eigene Variante mitkommt — ein Kunde
     würde sonst beim Farbwechsel unbemerkt darauf landen. */
  function passendeVariante(daten, auswahl) {
    if (!daten || !daten.variants || !daten.options) return null;

    var namen = daten.options.map(function (o) {
      return typeof o === 'string' ? o : o.name;
    });
    var gesucht = namen.map(function (name) {
      return auswahl[name];
    });
    if (gesucht.every(function (w) { return !w; })) return null;

    /* Gestuft statt alles-oder-nichts: Zuerst wird versucht, jede Option zu treffen.
       Gelingt das nicht, fallen die hinteren Wünsche nacheinander weg, bis etwas
       passt — die vorderen Optionen wiegen schwerer.

       Der Fall aus der Praxis: «Linoleum Pebble» führt zwar ein schwarzes Gestell,
       aber nicht in 1600 × 800 mm. Ohne Abstufung fand sich gar nichts und der Artikel
       landete auf seiner Standardvariante — mit weissem Gestell, obwohl die Farbe
       verfügbar gewesen wäre. Jetzt bleibt das schwarze Gestell erhalten und nur die
       Größe wechselt. */
    for (var tiefe = gesucht.length; tiefe > 0; tiefe--) {
      var treffer = daten.variants.find(function (variante) {
        return variante.options.every(function (wert, i) {
          // Hauptvariante in jeder Sprache/Schreibweise ausschliessen — Listen wie in
          // snippets/wb-hauptvariante.liquid (Stämme als Teilstring, «standard» u. ä. nur exakt)
          if (/default|d[ée]faut|predefin|predetermin|por defecto|padr[ãa]o|preimpost|domy[śs]ln|v[ýy]choz|alap[ée]rtelmez|varsay[ıi]lan|oletus|f[öo]rval|standardwert|standardverdi|standardv[æa]rdi|voreinstell|implicit|prednastav|privzet|zadan/i.test(wert)) return false;
          if (/^\s*(standard|standaard|standart|standardowy|standardowa|norm)\s*$/i.test(wert)) return false;
          if (i >= tiefe) return true;
          return !gesucht[i] || wert === gesucht[i];
        });
      });
      if (treffer) return treffer;
    }
    return null;
  }

  function holen(url) {
    if (speicher.has(url)) return speicher.get(url);
    var versprechen = fetch(url).then(function (antwort) {
      if (!antwort.ok) throw new Error('Status ' + antwort.status);
      return antwort.text();
    });
    /* Fehlschläge nicht dauerhaft merken — beim nächsten Versuch neu laden. */
    versprechen.catch(function () {
      speicher.delete(url);
    });
    merken(url, versprechen);
    return versprechen;
  }

  function holenJson(url) {
    return holen(url).then(function (text) {
      return JSON.parse(text);
    });
  }

  /* Bereitet einen Farbwechsel vor, ohne ihn anzuzeigen: Produktdaten holen,
     passende Variante bestimmen, Produktbereich abrufen. Läuft beim Überfahren
     des Farbpunkts, damit beim Klick meist nichts mehr zu warten ist. */
  /* 2026-10-07: Das neue Hauptbild schon anfordern, sobald das Section-Markup da ist — nicht erst, wenn der Browser nach
     Einsetzen, Swiper-Aufbau und Tooltips (am Handy mit 4× CPU-Drossel rund 2 s) das img-Element malt. Gemessen vorher:
     Markup 8,2 s nach dem Tipp, Bildabruf erst bei 10,4 s. Die Quelle steht nur im Markup (die Galerie wählt ihre Bilder
     über plenty-SKU-Metafelder; featured_image/variant.featured_image aus /products/x.js sind ANDERE Dateien — geprüft).
     Breite wie das Markup wählt: sizes = 100vw unter 990 px (→ 800), sonst 600 px (DPR > 1 → 800). Nur auf dem
     Klick-/Zeigerpfad (mitBild), nicht beim Vorladen im Leerlauf (dort bewusst nur Text). */
  /* 2026-10-09: (1) Die Regex vom 07.10. hatte ihre Backslashes verloren («[sS]*?», «ssrc=») und traf NIE — das Vorladen
     lief seit dem Live-Gang ins Leere (gemessen: alte Regex «KEIN TREFFER» am echten Section-HTML). (2) Statt die Breite zu
     raten, bekommt das Vorlade-Bild srcset/sizes des Markups — der Browser wählt dann exakt die Datei, die er für das echte
     img auch nehmen wird (sonst wäre der Vorrat nutzlos). (3) Rückgabe = Eintrag {fertig, versprechen} — ein Zwischenstand
     liess `wechseln` darauf warten; das ist auf Nutzerwunsch wieder raus, der Eintrag bleibt als Vorrat/Diagnose. */
  var vorgeladeneBilder = {};
  function hauptbildVorladen(html, imLeerlauf) {
    if (!html) return null;
    var tag = /id="main-swiper-[^"]*"[\s\S]*?<img([^>]*)>/.exec(html);
    if (!tag) return null;
    var attribut = function (name) {
      var m = new RegExp('\\s' + name + '="([^"]*)"').exec(tag[1]);
      return m ? m[1].replace(/&amp;/g, '&') : '';
    };
    var src = attribut('src');
    if (!src) return null;
    var srcset = attribut('srcset');
    var sizes = attribut('sizes');
    var schluessel = src + '|' + srcset + '|' + sizes;
    if (vorgeladeneBilder[schluessel]) return vorgeladeneBilder[schluessel];
    var bild = new Image();
    bild.decoding = 'async';
    /* Im Leerlauf hinter den sichtbaren Bildern der Seite einreihen. */
    if (imLeerlauf && 'fetchPriority' in bild) bild.fetchPriority = 'low';
    if (sizes) bild.sizes = sizes;
    if (srcset) bild.srcset = srcset;
    bild.src = src;
    var eintrag = { fertig: false, bild: bild };
    var geladen = new Promise(function (ok, nein) {
      bild.onload = function () { ok(); };
      bild.onerror = function () { nein(); };
      if (bild.complete && bild.naturalWidth) ok();
    });
    eintrag.versprechen = geladen
      .then(function () { return bild.decode ? bild.decode().catch(function () {}) : null; })
      .then(function () { eintrag.fertig = true; return true; }, function () { return false; });
    vorgeladeneBilder[schluessel] = eintrag;
    return eintrag;
  }

  /* 2026-10-19: Sofort-Bild (Vergleich mit desktronic.de, Nutzer: «unser Bildwechsel ist viel langsamer»). Gemessen am
     Desktop: Der Section-Tausch blockiert den Hauptthread 350–470 ms (Einsetzen 170–240, Swiper 60–120, Rest 110–130),
     und erst DANACH konnte der Browser das neue Hauptbild malen — bei vorgeladener Farbe 470–660 ms nach dem Klick.
     Desktronic tauscht nur das Bild im Slide (0,3 s inkl. Netz). Deshalb bekommt der aktive Hauptslide beim Klick zuerst
     die Bildquelle des Zielartikels (Vorrat aus hauptbildVorladen, je Pfad gemerkt — auch beim Leerlauf-Vorladen), der
     Browser malt einen Frame (nachDemMalen), und erst dann läuft der schwere Tausch. Ist das Bild noch unterwegs, zeigt
     der Browser beim src-Wechsel das alte weiter, bis das neue da ist — kein weisser Kasten. Thumbs und Text folgen mit
     dem Tausch (bei Desktronic ebenso: Thumb 0,13 s, Bild 0,3 s, Galerie-Neubau 1,3 s). */
  var bildFuerPfad = {};
  function sofortBild(pfad) {
    var eintrag = bildFuerPfad[pfad];
    if (!eintrag || !eintrag.bild) return false;
    var swiper = document.querySelector('[id^="main-swiper-"]');
    if (!swiper) return false;
    var ziel = swiper.querySelector('.swiper-slide-active img') || swiper.querySelector('.swiper-slide img');
    if (!ziel) return false;
    var quelle = eintrag.bild;
    var src = quelle.getAttribute('src') || '';
    if (!src) return false;
    var srcset = quelle.getAttribute('srcset') || '';
    var sizes = quelle.getAttribute('sizes') || '';
    if (ziel.getAttribute('src') === src && (ziel.getAttribute('srcset') || '') === srcset) return false;
    /* Das Lade-Deck der Galerie (od-product-media-gallery-new.liquid) läge sonst mit dem alten Bild darüber. */
    Array.prototype.forEach.call(document.querySelectorAll('[id^="wb-lade-deck-"]'), function (deck) {
      deck.remove();
    });
    if (sizes) ziel.setAttribute('sizes', sizes);
    if (srcset) ziel.setAttribute('srcset', srcset);
    else ziel.removeAttribute('srcset');
    ziel.setAttribute('src', src);
    return true;
  }

  /* Einen Frame malen lassen, dann weiter (rAF → setTimeout 0). Sicherheitsnetz 150 ms, falls der Tab im
     Hintergrund liegt und kein Frame kommt. */
  function nachDemMalen(fn) {
    var erledigt = false;
    var weiter = function () {
      if (erledigt) return;
      erledigt = true;
      fn();
    };
    window.requestAnimationFrame(function () {
      window.setTimeout(weiter, 0);
    });
    window.setTimeout(weiter, 150);
  }

  function vorbereiten(zielUrl, sid, mitBild) {
    var pfad = zielUrl.split('?')[0];
    var auswahl = auswahlLesen();

    return holenJson(pfad + '.js')
      .then(function (daten) {
        var variante = passendeVariante(daten, auswahl);
        /* 2026-09-09: /products/<handle>.js liefert hoechstens 250 Varianten. Ist
           die Liste voll und nichts passt, wird die Section ohne Vorauswahl
           geholt — der Kunde waehlt dann im neuen Artikel, statt auf einer
           falschen Variante zu landen. Sichtbar machen, damit es beim Messen
           nicht als Theme-Fehler durchgeht. */
        if (!variante && daten.variants && daten.variants.length >= 250) {
          console.warn('wb-color-swap: Zielartikel hat 250+ Varianten, Auswahl wird nicht uebertragen');
        }
        var abruf = pfad + '?section_id=' + encodeURIComponent(sid);
        if (variante) abruf += '&variant=' + variante.id;

        /* Judge.me-Review-Widget des Zielartikels parallel mitholen. Ein Fehlschlag
           bricht hier nichts ab — `ausfuehren` prüft das Ergebnis und fällt dann auf
           normale Navigation zurück. */
        var bewertungen = bewertungsSection();
        var bewertungenAbruf = bewertungen
          ? holen(pfad + '?section_id=' + encodeURIComponent(bewertungen.id.slice('shopify-section-'.length))).catch(
              function () {
                return null;
              },
            )
          : Promise.resolve(null);

        var vorlagen = bewertungen
          ? Promise.all([vorlageHolen(window.location.pathname.replace(/\/$/, '')), vorlageHolen(pfad)])
          : Promise.resolve([null, null]);

        var revampKlasse = bewertungen && wbRevampAktiv() ? revampKlasseLaden() : Promise.resolve(null);

        /* Material-Section(en) des Zielartikels parallel mitholen (siehe ZUSATZ_SECTIONS). */
        var zusatzAbruf = Promise.all(
          zusatzSections().map(function (el) {
            return holen(pfad + '?section_id=' + encodeURIComponent(el.id.slice('shopify-section-'.length)))
              .then(function (html) {
                return { id: el.id, html: html };
              })
              .catch(function () {
                return { id: el.id, html: null };
              });
          }),
        );

        return Promise.all([holen(abruf), bewertungenAbruf, vorlagen, revampKlasse, zusatzAbruf]).then(function (antworten) {
          /* 2026-10-19: Hauptbild auch im Leerlauf mitholen (vorher nur Text) und je Pfad merken — Vorrat für sofortBild. */
          var bildEintrag = hauptbildVorladen(antworten[0], !mitBild);
          if (bildEintrag) bildFuerPfad[pfad] = bildEintrag;
          var vorlageHier = antworten[2][0];
          var vorlageZiel = antworten[2][1];
          return {
            html: antworten[0],
            bewertungenHtml: antworten[1],
            revampKlasse: antworten[3],
            vorlageGleich: vorlageHier !== null && vorlageZiel !== null && vorlageHier === vorlageZiel,
            ziel: pfad,
            titel: daten.title,
            produktId: daten.id,
            variante: variante,
            zusatz: antworten[4],
          };
        });
      });
  }

  /* Inline-Skripte laufen nicht mit, wenn Markup über innerHTML eingesetzt wird.
     Nachgezogen wird deshalb gezielt, was den ausgetauschten Bereich aufbaut:
     die Skripte innerhalb von product-info (u. a. der Options-Picker) und der
     Aufbau des Galerie-Sliders, der ausserhalb davon steht. Alles Übrige der
     Section bleibt unangetastet — es würde sonst ein zweites Mal globale
     Ereignisse registrieren.

     Der Galerie-Aufbau steckt vollständig in einem `DOMContentLoaded`-Handler
     (snippets/od-product-media-gallery-new.liquid). Das Ereignis ist längst
     vorbei und kommt nie wieder — nachgezogen würde der Handler also nur
     registriert und nie ausgeführt, und die Galerie bliebe ohne Slider stehen.
     Deshalb wird `document.addEventListener` für die Dauer der Ausführung so
     umgestellt, dass ein solcher Handler sofort läuft. Das ist unabhängig von
     der genauen Schreibweise im Agentur-Code und übersteht dessen Änderungen.

     `keydown` wird dabei übergangen: Der einzige globale Handler dieser Art
     schliesst die Lightbox und sucht sie sich selbst über den DOM. Er wirkt
     also weiterhin, und ohne diese Ausnahme käme bei jedem Farbwechsel ein
     weiterer hinzu. */
  /* Wunschliste (App «iWish», Link `a.iWishAdd` in der Kaufbox): Die App bindet
     ihren Klick-Handler nur EINMAL beim Seitenstart an die damals vorhandenen
     Links (`iwishAddClick`, markiert sie mit data-iwClick). Nach dem Austausch
     der Section ist der neue Link «nackt» — der Tipp fiel auf `href="#"` durch
     und die Seite sprang zum Anfang (gemeldet 2026-08-23, «lädt neu», nur nach
     einem Farbwechsel). Deshalb hier neu anbinden; dazu den Zustand «schon
     gemerkt» für die neue Variante setzen. Alles defensiv: fehlt die App, passiert
     nichts. */
  function wunschlisteNeuAnbinden(wurzel) {
    var app = window.iWish;
    if (!app || typeof app.iwishAddClick !== 'function') return;
    Array.prototype.forEach.call(wurzel.querySelectorAll('.iWishAdd'), function (link) {
      try {
        app.iwishAddClick(link);
        var variante = link.getAttribute('data-variant');
        if (variante && typeof app.isInWishlist === 'function' && app.isInWishlist(variante)) {
          if (typeof app.setIwishAdded === 'function') app.setIwishAdded(link);
        }
      } catch (fehler) {
        /* App-Interna können sich ändern — dann bleibt es beim Link ohne Handler. */
      }
    });
  }

  /* Höhensprung beim Austausch vermeiden (Nutzer 2026-08-25: «der In-den-
     Warenkorb-Knopf springt während des Ladens kurz»). Gemessen am iPhone-
     Format: Die Galerie ist zwischen dem Einsetzen des Markups und der
     Initialisierung des Sliders rund 50 px niedriger (364 -> 314 -> 364 über
     etwa 180 ms) — mobil steht die Kaufbox darunter, also wandert alles
     darin hoch und gleich wieder zurück. Deshalb die vorherige Höhe als
     Mindesthöhe festhalten und erst freigeben, wenn der Slider steht. */
  function galerieHoeheHalten(wurzel, hoehe) {
    /* Gehalten wird die ganze BILDSPALTE, nicht nur der Galerie-Container:
       zwischen beiden liegen rund 20 px Abstand, die sonst weiterhin kurz
       wegfielen — gemessen 384 -> 364 -> 384 (2026-08-25). */
    var galerie =
      wurzel.querySelector('.product__media-wrapper') ||
      wurzel.querySelector('[id^="product-media-gallery-"]');
    if (!galerie || !hoehe) return;
    galerie.style.minHeight = hoehe + 'px';

    var beobachter = null;
    var netz = 0;
    var erledigt = false;

    function freigeben() {
      if (erledigt) return;
      erledigt = true;
      galerie.style.minHeight = '';
      if (beobachter) beobachter.disconnect();
      if (netz) window.clearTimeout(netz);
    }

    /* Zwei Frames warten: Der erste zeichnet das Layout mit gehaltener Höhe,
       im zweiten hat der Slider seine Masse gesetzt. */
    function baldFreigeben() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(freigeben);
      });
    }

    var haupt = galerie.querySelector('[id^="main-swiper-"]');
    if (!haupt) {
      baldFreigeben();
      return;
    }
    if (haupt.classList.contains('swiper-initialized')) {
      baldFreigeben();
      return;
    }
    if (typeof MutationObserver === 'function') {
      beobachter = new MutationObserver(function () {
        if (haupt.classList.contains('swiper-initialized')) baldFreigeben();
      });
      beobachter.observe(haupt, { attributes: true, attributeFilter: ['class'] });
    }
    /* Sicherheitsnetz: Scheitert der Slider, darf die Höhe nicht dauerhaft
       festgenagelt bleiben. */
    netz = window.setTimeout(freigeben, 1500);
  }


  function skripteAusfuehren(wurzel) {
    var kandidaten = Array.from(wurzel.querySelectorAll('script')).filter(function (skript) {
      /* Dateien sind bereits geladen und wirken global — nur die eingebetteten
         Bausteine der Section müssen erneut laufen. JSON sind Daten, kein Code. */
      var typ = (skript.type || '').toLowerCase();
      /* Nur echtes JavaScript: JSON-LD (`application/ld+json`, Produktdaten für
         Google) lief bisher als Code durch und brach mit «Unexpected token ':'» ab
         (2026-08-23). */
      return !skript.src && (typ === '' || typ === 'text/javascript' || typ === 'module');
    });

    /* Zuerst aufräumen, was der vorige Wechsel hinterlassen hat.

       Die Skripte der Section hängen sich bei jedem Durchlauf an `window` und
       `document` (gemessen: rund sieben pro Wechsel — scroll, resize, blur, focus,
       popstate, error, pagehide). Ohne diesen Abbau sammeln sie sich an, laufen
       fortan bei jedem Scrollen und Klicken mit und machen die Seite spürbar zäh.

       Bewusst NICHT blockiert, sondern nur ersetzt: Der Galerie-Slider braucht seinen
       resize-Handler, sonst reagiert er nicht mehr auf Fensterbreiten. Aufgeräumt wird
       ausschliesslich, was aus einem vorherigen Nachzieh-Lauf stammt — was die Seite
       beim ersten Laden registriert hat, bleibt unangetastet. */
    nachgezogeneListener.forEach(function (eintrag) {
      try {
        eintrag.ziel.removeEventListener(eintrag.typ, eintrag.fn, eintrag.optionen);
      } catch (e) {
        /* Ein bereits entfernter Handler ist kein Grund abzubrechen. */
      }
    });
    nachgezogeneListener = [];

    var echtesDokument = document.addEventListener;
    var echtesFenster = window.addEventListener;

    /* `DOMContentLoaded` läuft SOFORT: Das Ereignis ist längst vorbei und kommt nie
       wieder; ein nachgezogener Handler (etwa der komplette Galerie-Aufbau in
       od-product-media-gallery-new.liquid) würde sonst nur registriert und nie
       ausgeführt — die Galerie bliebe ohne Slider zurück. */
    document.addEventListener = function (typ, fn, optionen) {
      if (typ === 'DOMContentLoaded' && typeof fn === 'function') {
        fn();
        return;
      }
      nachgezogeneListener.push({ ziel: document, typ: typ, fn: fn, optionen: optionen });
      return echtesDokument.call(document, typ, fn, optionen);
    };

    window.addEventListener = function (typ, fn, optionen) {
      nachgezogeneListener.push({ ziel: window, typ: typ, fn: fn, optionen: optionen });
      return echtesFenster.call(window, typ, fn, optionen);
    };

    try {
      kandidaten.forEach(function (alt) {
        var neu = document.createElement('script');
        neu.textContent = alt.textContent;
        document.body.appendChild(neu);
        document.body.removeChild(neu);
      });
    } finally {
      document.addEventListener = echtesDokument;
      window.addEventListener = echtesFenster;
    }
  }

  /* Zeitmessung der Teilschritte, abrufbar über `window.wbColorSwapZeiten`.
     Kostet nichts Nennenswertes und erspart bei jeder künftigen Änderung das
     Raten, welcher Schritt die Wartezeit verursacht. */
  var zeiten = {};
  window.wbColorSwapZeiten = zeiten;

  /* Akkordeon «Produktbeschreibung» (snippets/od-product-accordion.liquid) klappenweise
     behalten statt neu einsetzen (2026-10-08).

     Das Akkordeon stellt rund ein Drittel aller Elemente der Hauptsection (gemessen
     TELDRA Home: 363 von 1155, allein die FAQ 201) und wechselt zwischen Farbartikeln
     meist gar nicht: FAQ, Downloads, Versand und Kontakt sind je Modell gleich, die
     Beschreibung je Grösse. Bisher wurde es trotzdem bei jedem Wechsel entfernt und
     neu geparst, gelayoutet und — per verschieben() in main-product.liquid — erneut
     vor den Crossseller gehängt; dabei klappte alles zu, was der Kunde geöffnet hatte.

     Jetzt: Ist das alte Akkordeon schon aus der Section heraus verschoben
     (data-wb-verschoben="1"), werden seine Klappen einzeln mit der neuen Fassung
     verglichen. Gleiche Klappen bleiben stehen (mitsamt Klappzustand und einem evtl.
     laufenden Vimeo-Player), ungleiche werden einzeln ersetzt — mit dem Klappzustand der
     alten Fassung. Das neue Akkordeon wird aus dem Zielmarkup entfernt, damit
     inhaltErsetzen es nicht einsetzt; verschieben() findet dann keins in der Section und
     tut nichts (sein Aufräumen entfernter Fassungen läuft erst danach).

     Verglichen wird das serialisierte Markup ohne das, was sich zur Laufzeit ändert:
     `open` (Klappen sind native <details>, die Snippets haben keine Skripte),
     `data-wb-verschoben` sowie `role`/`aria-expanded`/`aria-controls`/`tabindex`, die ein
     Theme-Skript nach dem Laden an die <summary> hängt (gemessen: nur deshalb galt die
     FAQ als «anders»). Der Inhalt von JSON-LD-Skripten bleibt beim Vergleich aussen vor —
     die FAQPage-Daten tragen den Produktnamen; bei einer behaltenen Klappe wird nur dieser
     Skripttext übernommen (kein Layout). Jede andere Abweichung gilt als «ungleich» —
     dann wird die Klappe ersetzt, es gibt also keinen Zustand, in dem Inhalt des vorigen
     Artikels stehen bleibt. Ist das Akkordeon nicht verschoben oder die Blockzahl
     verschieden, läuft alles wie bisher (Rückgabe null). */
  var LD_JSON = 'script[type="application/ld+json"]';

  function akkordeonNormieren(html) {
    return html
      .replace(/<script type="application\/ld\+json">[\s\S]*?<\/script>/g, '<script type="application/ld+json"></script>')
      .replace(/\s+(?:open|data-wb-verschoben|role|aria-expanded|aria-controls|tabindex)(?:="[^"]*")?(?=[\s>])/g, '')
      .replace(/\s+/g, ' ');
  }

  function akkordeonAbgleichen(wurzelAlt, wurzelNeu) {
    var neu = wurzelNeu.querySelector('.wb-product-description');
    var alt = document.querySelector('.wb-product-description[data-wb-verschoben="1"]');
    if (!neu || !alt || wurzelAlt.contains(alt)) return null;
    /* Der Klappen-Container ist das Elternelement der .product__accordion-Blöcke — nicht
       das erste Kind des Wrappers, das ist der <style>-Block des Snippets. */
    var ersteAlt = alt.querySelector('.product__accordion');
    var ersteNeu = neu.querySelector('.product__accordion');
    var innenAlt = ersteAlt && ersteAlt.parentElement;
    var innenNeu = ersteNeu && ersteNeu.parentElement;
    if (!innenAlt || !innenNeu || !innenAlt.children.length || innenAlt.children.length !== innenNeu.children.length) return null;

    var kinderAlt = Array.prototype.slice.call(innenAlt.children);
    var kinderNeu = Array.prototype.slice.call(innenNeu.children);
    var behalten = 0;
    var ersetzt = 0;
    kinderAlt.forEach(function (a, i) {
      var n = kinderNeu[i];
      if (akkordeonNormieren(a.outerHTML) === akkordeonNormieren(n.outerHTML)) {
        /* Behalten — nur die Daten der JSON-LD-Skripte auf den Zielartikel bringen. */
        var ldAlt = a.querySelectorAll(LD_JSON);
        var ldNeu = n.querySelectorAll(LD_JSON);
        if (ldAlt.length === ldNeu.length) {
          for (var k = 0; k < ldAlt.length; k++) ldAlt[k].textContent = ldNeu[k].textContent;
        }
        behalten++;
        return;
      }
      var kopie = document.importNode(n, true);
      /* Klappzustand des Kunden übernehmen: verschieben() läuft für das behaltene
         Akkordeon nicht mehr, ohne diese Zeilen käme die erste Klappe frisch geöffnet
         zurück, obwohl sie auf Seiten mit Inhalts-Sections geschlossen startet. */
      var klappenAlt = a.querySelectorAll('details');
      var klappenNeu = kopie.querySelectorAll('details');
      if (klappenAlt.length === klappenNeu.length) {
        for (var j = 0; j < klappenAlt.length; j++) {
          if (klappenAlt[j].hasAttribute('open')) klappenNeu[j].setAttribute('open', '');
          else klappenNeu[j].removeAttribute('open');
        }
      }
      a.parentNode.replaceChild(kopie, a);
      ersetzt++;
    });

    neu.parentNode.removeChild(neu);
    return { behalten: behalten, ersetzt: ersetzt };
  }

  /* Die Stylesheet-Links der Section bleiben beim Austausch stehen.

     Die Section bindet ihre CSS-Dateien selbst ein — `section-main-product.css`,
     `component-price.css` usw., neun `<link rel="stylesheet">` direkt unter der
     Section. Wird ihr Markup per `innerHTML` ersetzt, entstehen diese Links neu, und
     der Browser lädt ihre Sheets asynchron nach, auch aus dem Cache: gemessen rund
     100 ms, in denen KEINE Regel aus diesen Dateien gilt. Der Kaufspalte fehlte
     dabei ihr `padding-left: 5rem`, sie stand 48 px weiter links und sprang dann
     zurück (gemeldet 2026-08-27: «Zahlarten und „Mehr als …“ verschieben sich
     beim Laden»). Verschieben hilft nicht — auch ein innerhalb des Dokuments
     umgehängter Link verliert sein Sheet (gemessen).

     Deshalb bleiben die vorhandenen Links unangetastet an ihrem Platz; ersetzt wird
     nur der Rest, in der ursprünglichen Reihenfolge, damit die Kaskade dieselbe
     bleibt. Links, die im neuen Markup fehlen, werden entfernt; neue eingesetzt.
     Die Knoten zwischen zwei Links gehen als EIN Fragment hinein, damit die
     Custom Elements — wie bei `innerHTML` — erst aufwachen, wenn ihre Geschwister
     schon im Dokument stehen. Eingesetzt werden Kopien (`importNode`), damit das
     geparste Markup für `skripteAusfuehren` unverändert bleibt. */
  function inhaltErsetzen(alt, neu) {
    function istStylesheet(knoten) {
      return (
        knoten.nodeType === 1 &&
        knoten.tagName === 'LINK' &&
        knoten.relList &&
        knoten.relList.contains('stylesheet')
      );
    }

    var behalten = Array.prototype.filter.call(alt.children, istStylesheet);

    Array.prototype.slice.call(alt.childNodes).forEach(function (knoten) {
      if (behalten.indexOf(knoten) === -1) alt.removeChild(knoten);
    });

    var i = 0;
    var sammler = document.createDocumentFragment();

    function sammlerEinsetzen() {
      if (sammler.childNodes.length) {
        alt.insertBefore(sammler, i < behalten.length ? behalten[i] : null);
      }
    }

    Array.prototype.slice.call(neu.childNodes).forEach(function (knoten) {
      if (istStylesheet(knoten)) {
        var href = knoten.getAttribute('href');
        for (var j = i; j < behalten.length; j++) {
          if (behalten[j].getAttribute('href') === href) {
            sammlerEinsetzen();
            /* Alte Links davor, die im neuen Markup fehlen, sind überholt. */
            while (i < j) alt.removeChild(behalten[i++]);
            i = j + 1;
            return;
          }
        }
      }
      sammler.appendChild(document.importNode(knoten, true));
    });

    sammlerEinsetzen();
    while (i < behalten.length) alt.removeChild(behalten[i++]);
  }

  /* 2026-10-21 (Nutzer: «am iPhone beim Wechseln über die Farbpunkte blinken diese pro Wechsel einmal auf, aber nur
     bei Safari»): Die Farbpunkt-Zeile wurde mit der ganzen Section ersetzt — dieselben Punkte, dieselben Bilder, nur
     neu ins DOM gesetzt. Safari malt neu eingefügte Knoten erst einen Frame später (Playwright-WebKit und Chromium
     zeigen das nicht; Lehre vom 20.10., «roter Strich» am Modell-Tab). Deshalb bleibt die ALTE Zeile stehen, wenn
     das neue Markup dieselben Punkte (gleiche Links) enthält; nur Aktiv-Markierung, Häkchen und Attribute werden
     vom neuen Markup übernommen. Andere Punktmenge (einseitige plenty-Listen, memory/07) → neue Zeile wie bisher. */
  function punkteZeile(wurzel) {
    var alle = wurzel.querySelectorAll('.crossseller-wrapper');
    if (!alle.length) return null;
    var knoten = alle[0].parentElement;
    while (knoten && knoten !== wurzel && knoten.querySelectorAll('.crossseller-wrapper').length < alle.length) {
      knoten = knoten.parentElement;
    }
    return knoten && knoten !== wurzel ? knoten : null;
  }

  function punktePfad(link) {
    return (link.getAttribute('href') || '').split('?')[0];
  }

  function punkteBehalten(wurzel, alt) {
    if (!alt) return false;
    var neu = punkteZeile(wurzel);
    if (!neu || neu === alt || !neu.parentNode) return false;
    var linksAlt = alt.querySelectorAll('.crossseller-wrapper > a[href]');
    var linksNeu = neu.querySelectorAll('.crossseller-wrapper > a[href]');
    if (!linksAlt.length || linksAlt.length !== linksNeu.length) return false;
    var vorlagen = {};
    Array.prototype.forEach.call(linksNeu, function (a) { vorlagen[punktePfad(a)] = a; });
    for (var i = 0; i < linksAlt.length; i++) {
      if (!vorlagen[punktePfad(linksAlt[i])]) return false;
    }
    var haken = alt.querySelector('.wb-color-dot-check') || neu.querySelector('.wb-color-dot-check');
    Array.prototype.forEach.call(linksAlt, function (a) {
      var vorlage = vorlagen[punktePfad(a)];
      var aktiv = vorlage.hasAttribute('aria-current');
      a.className = vorlage.className;
      if (aktiv) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      if (vorlage.hasAttribute('data-wb-kein-vorladen')) a.setAttribute('data-wb-kein-vorladen', '');
      else a.removeAttribute('data-wb-kein-vorladen');
      var h = a.querySelector('.wb-color-dot-check');
      if (aktiv && !h && haken) a.insertBefore(haken.cloneNode(true), a.firstChild);
      if (!aktiv && h) a.removeChild(h);
    });
    neu.parentNode.replaceChild(alt, neu);
    return true;
  }

  function ausfuehren(daten, sid, mitHistorie) {
    var zeitStart = performance.now();
    var neu = new DOMParser().parseFromString(daten.html, 'text/html');
    var zeitGeparst = performance.now();

    /* Ausgetauscht wird die GESAMTE Section, nicht nur Kaufbereich und Galerie.
       Produktabhängig sind auch technische Daten, die Beschreibungs-Akkordeons, das
       Varianten-Slideover und die Auszeichnungen — sie liegen ausserhalb von
       `product-info` und blieben sonst auf dem vorherigen Artikel stehen. Genau
       daraus entstanden fremde Optionsfelder im Kaufbereich.
       Einzige Ausnahme seit 2026-10-08: das bereits verschobene Beschreibungs-Akkordeon
       wird klappenweise verglichen und nur dort ersetzt, wo es sich unterscheidet
       (akkordeonAbgleichen). */
    var wurzelAlt = document.getElementById(SECTION_PRAEFIX + sid);
    var wurzelNeu = neu.getElementById(SECTION_PRAEFIX + sid);

    /* Fehlt die Section, stimmt etwas nicht — dann lieber gar nicht eingreifen,
       damit keine halbe Produktseite stehen bleibt. */
    if (!wurzelAlt || !wurzelNeu) return false;

    /* Judge.me-Review-Widget: VOR dem ersten Eingriff prüfen, ob für den Zielartikel
       ein vollständiges Widget vorliegt. Wenn nicht, normal navigieren (Rückgabe
       false) — es darf nie das Widget des vorherigen Artikels stehen bleiben. */
    var bewertungenAlt = bewertungsSection();
    var bewertungenNeu = null;
    var bewertungenRevamp = null;
    var bewertungenEinrichtenNoetig = false;
    if (bewertungenAlt) {
      /* Anderes (oder nicht ermittelbares) product.*.json-Template → normale Navigation. */
      if (!daten.vorlageGleich) return false;
      if (wbRevampAktiv()) {
        /* Widget 3.0 auf dieser Seite: nur tauschen, wenn auch der Zielartikel Widget 3.0
           bekommt und sich Judge.mes Widget-Klasse starten lässt (siehe revampLesen). */
        bewertungenRevamp = revampLesen(daten, bewertungenAlt.id);
        if (!bewertungenRevamp) return false;
      } else {
        bewertungenNeu = bewertungenNeuLesen(daten, bewertungenAlt.id);
        if (!bewertungenNeu) return false;
        /* Judge.me läuft, liesse sich aber nicht neu anstossen → gar nicht erst tauschen. */
        bewertungenEinrichtenNoetig = jdgmLaeuft();
        if (bewertungenEinrichtenNoetig && !jdgmEinrichtbar()) return false;
      }
    }

    /* Material-Section: Die Zielfassung muss vorliegen, sonst normal navigieren — es darf nie
       der Plattentext des vorherigen Artikels stehen bleiben. */
    var zusatzNeu = [];
    if (daten.zusatz) {
      for (var zi = 0; zi < daten.zusatz.length; zi++) {
        var zusatzAlt = document.getElementById(daten.zusatz[zi].id);
        if (!zusatzAlt) continue;
        if (!daten.zusatz[zi].html) return false;
        var zusatzDok = new DOMParser().parseFromString(daten.zusatz[zi].html, 'text/html');
        var zusatzZiel = zusatzDok.getElementById(daten.zusatz[zi].id);
        if (!zusatzZiel) return false;
        zusatzNeu.push({ alt: zusatzAlt, neu: zusatzZiel });
      }
    }

    /* Die alte Slider-Instanz zeigt gleich auf entfernte Knoten. */
    if (window.mainswiper && typeof window.mainswiper.destroy === 'function') {
      try {
        window.mainswiper.destroy(true, true);
      } catch (e) {
        /* Eine bereits zerstörte Instanz ist kein Grund abzubrechen. */
      }
    }

    /* Für das mobile Bild-Kleben (sections/main-product.liquid): merken, ob das
       Bild gerade fixiert war — der Austausch wirft Bild und Platzhalter weg,
       und im Hysterese-Randbereich würde das neue Bild sonst nicht wieder
       fixiert («beim Wechseln verschwindet das Bild»). */
    window.wbBildWarFixiert = wurzelAlt.querySelector('.wb-bild-fixiert')
      ? performance.now()
      : 0;
    /* 2026-10-07: Scrollposition zum Start des Zeitfensters — das Kleben darf im Fenster lösen, wenn der
       Kunde währenddessen weiterscrollt (sections/main-product.liquid, pruefen). */
    window.wbBildWechselY = window.scrollY;

    /* Klebt gerade ein Bild? Dann dessen Klon stehen lassen, bis das neue
       Bild fixiert UND geladen ist — sonst blitzt beim Austausch Weiss auf
       (gleiches Rezept wie beim Optionswechsel, sections/main-product.liquid). */
    if (window.wbBildWarFixiert && window.wbKlonZeigen) window.wbKlonZeigen();

    /* Klebt das Bild am Handy gerade oben fest, muss es VOR dem Austausch
       geloest werden: Sein Platzhalter liegt im ersetzten Markup, und ein
       danach neu gesetzter Platzhalter kaeme zur gehaltenen min-height hinzu
       — die Seite sprang dadurch um eine Bildhoehe (2026-09-17). Loesen
       stellt den Originalzustand her und veraendert die Hoehe nicht. */
    /* 2026-10-09: Der Klon wird hier mit gelöst (kein zweiter Parameter). Zwischenstand vom Mittag — Klon bleibt bis zum
       geladenen Foto — ist zurückgenommen (Nutzer: «lieber komplett weiss werden lassen»). Das Hauptbild ist durch
       hauptbildVorladen meist schon dekodiert und malt dann im selben Frame wie der Text; sonst ist der Kasten kurz weiss. */
    if (typeof window.wbBildLoesen === 'function') {
      try { window.wbBildLoesen(); } catch (e) {}
    }

    /* Nach einem Austausch ist die gemerkte Scrollrichtung wertlos — beim
       Wechsel wurde nicht gescrollt, und ein stehengebliebenes "aufwaerts"
       haette verhindert, dass das Bild beim naechsten Runterscrollen wieder
       klebt. Zuruecksetzen laesst die Erkennung frisch anlaufen. */
    window.wbLetzteScrollY = null;
    window.wbRunter = true;

    /* Vor dem Ersetzen die Galerie-Hoehe merken (siehe galerieHoeheHalten). */
    var galerieAlt =
      wurzelAlt.querySelector('.product__media-wrapper') ||
      wurzelAlt.querySelector('[id^="product-media-gallery-"]');
    var galerieHoehe = galerieAlt ? Math.round(galerieAlt.getBoundingClientRect().height) : 0;

    /* Produktname und Intro-Text NICHT mitwechseln (Nutzerwunsch 2026-08-26):
       Die Farbartikel sind dasselbe Modell, ihre Texte unterscheiden sich nur
       um Kleinigkeiten — beim Klick auf einen Farbpunkt sprang der Text
       trotzdem sichtbar um und lenkte vom Bild ab. Die alten Knoten werden
       deshalb vor dem Austausch gesichert und danach wieder eingesetzt.
       Bewusst in Kauf genommen: Steht im Namen des Zielartikels etwas anderes,
       bleibt der bisherige Text stehen. Beim normalen Seitenaufruf (und nach
       einem Reload) zeigt jeder Artikel weiterhin seinen eigenen Text. */
    /* Gesichert wird der ganze Knoten, nicht nur sein Inhalt: Fehlt der Block beim
       Zielartikel, kann er so wieder eingesetzt werden.
       Die Highlights-Liste (.wb-ph-list) wechselt dagegen MIT (Nutzerwunsch
       2026-09-18): Ihre Punkte beschreiben den Zielartikel (Masse, Material) und
       muessen stimmen. Sie steht am Ende der Kaufbox, also UNTER den Farbpunkten
       und der Groessenwahl — ihre Hoehe verschiebt nichts, was beim Klick im Bild
       ist; alles darueber haelt der Scroll-Anker unten fest. */
    /* Scroll-Anker: Bildschirmposition der Farbpunkt-Zeile VOR dem Austausch.
       Chrome verankert bei Hoehenaenderungen automatisch, Safari nicht — am iPhone
       sprang die Ansicht deshalb, wenn sich ueber den Punkten etwas aenderte
       (Nutzermeldung 2026-09-17, "ich springe oft in die fancydetails rein"). */
    var ankerAlt = wurzelAlt.querySelector('.wb-finish-dots, .crossseller-wrapper');
    var ankerTopAlt = ankerAlt ? ankerAlt.getBoundingClientRect().top : null;

    var texteBehalten = {};
    ['.wb-buybox-title', '.wb-ph-intro'].forEach(function (waehler) {
      var knoten = wurzelAlt.querySelector(waehler);
      if (knoten) {
        var elternKlasse = knoten.parentElement && knoten.parentElement.classList.length
          ? knoten.parentElement.classList[0] : '';
        texteBehalten[waehler] = { klon: knoten.cloneNode(true), eltern: elternKlasse };
      }
    });

    var akkordeon = akkordeonAbgleichen(wurzelAlt, wurzelNeu);
    zeiten.akkordeon = akkordeon ? akkordeon.behalten + ' behalten, ' + akkordeon.ersetzt + ' ersetzt' : 'komplett';
    var punkteAlt = punkteZeile(wurzelAlt);

    /* 2026-10-20: Nachgeladene Teile (snippets/wb-nachladen.liquid: Modellwechsel, FAQ) aus dem alten Markup
       übernehmen, damit beim Tausch nichts aufblitzt; frisch für den Zielartikel geholt wird gleich nach den
       Skripten (window.wbNachladen mit daten.ziel). */
    var nachladeAlt = {};
    Array.prototype.forEach.call(wurzelAlt.querySelectorAll('[data-wb-nachladen]'), function (platz) {
      nachladeAlt[platz.getAttribute('data-wb-nachladen')] = platz;
    });

    inhaltErsetzen(wurzelAlt, wurzelNeu);

    /* 2026-10-20 abends (Nutzer: «der rote Strich blinkt jedesmal, wenn ich die Tischplattenfarbe wechsle»): Der neue
       Platzhalter bringt sein Gerüst OHNE aktiven Tab mit — deshalb das Gerüst durch das alte, fertig geladene Markup
       ersetzen (nicht nur in leere Platzhalter füllen); der aktive Tab bleibt so durchgehend stehen. */
    Array.prototype.forEach.call(wurzelAlt.querySelectorAll('[data-wb-nachladen]'), function (platz) {
      var alt = nachladeAlt[platz.getAttribute('data-wb-nachladen')];
      if (!alt || !alt.getAttribute('data-wb-geladen')) return;
      while (platz.firstChild) platz.removeChild(platz.firstChild);
      while (alt.firstChild) platz.appendChild(alt.firstChild);
    });

    /* 2026-10-21: Farbpunkt-Zeile behalten (siehe punkteBehalten) — gegen das Aufblitzen in Safari. */
    zeiten.punkte = punkteBehalten(wurzelAlt, punkteAlt) ? 'behalten' : 'ersetzt';

    Object.keys(texteBehalten).forEach(function (waehler) {
      var ziel = wurzelAlt.querySelector(waehler);
      var gesichert = texteBehalten[waehler];
      if (ziel) {
        ziel.innerHTML = gesichert.klon.innerHTML;
        return;
      }
      /* Der Zielartikel hat den Block gar nicht (leeres description_short, z. B.
         TELDRA Home Ahorn/Cubanitgrau). Den gesicherten Knoten in DENSELBEN Elternteil
         haengen wie im Original: Das Intro lebt im Titel-Block `.product__title`
         (Reihenfolge 0, direkt unter dem Namen) — direkt in der Kaufbox bekaeme es
         die Default-Reihenfolge 12 und stuende unter dem Kaufen-Knopf (2026-09-17
         gemessen: y 657 -> 1105). Die Liste lebt in der Kaufbox selbst (order 20). */
      var eltern = (gesichert.eltern && wurzelAlt.querySelector('.' + gesichert.eltern))
        || wurzelAlt.querySelector('.product__info-container');
      if (eltern) eltern.appendChild(gesichert.klon);
    });

    galerieHoeheHalten(wurzelAlt, galerieHoehe);

    /* Scroll-Anker anwenden: Die Farbpunkt-Zeile soll dort stehen, wo sie vor dem
       Klick stand. Nur bei echter Verschiebung scrollen — und nie ueber die
       Seitenoberkante hinaus (dann bleibt es beim Rand). */
    if (ankerTopAlt !== null) {
      var ankerNeu = wurzelAlt.querySelector('.wb-finish-dots, .crossseller-wrapper');
      if (ankerNeu) {
        var versatz = ankerNeu.getBoundingClientRect().top - ankerTopAlt;
        if (Math.abs(versatz) > 1) window.scrollBy(0, versatz);
      }
    }
    var zeitEingesetzt = performance.now();

    auswahlfelderAngleichen(daten.variante);

    /* Der Lieferkasten (snippets/wb-delivery-box.liquid) hängt an der Variante
       und wird beim Angleichen nicht serverseitig neu gerendert — er hört auf
       dieses Ereignis und blendet die passende vorgerenderte Fassung ein. */
    document.dispatchEvent(
      new CustomEvent('wb:variantenwechsel', {
        detail: { variantId: daten.variante && daten.variante.id },
      }),
    );

    skripteAusfuehren(wurzelNeu);
    var zeitSkripte = performance.now();

    /* 2026-10-20: Modellwechsel/FAQ für den Zielartikel nachladen (Pfad explizit — pushState kommt erst weiter unten).
       Dokumentweit, nicht nur in der Section: Das Beschreibungs-Akkordeon mit dem FAQ-Platzhalter ist verschoben
       (verschieben(), data-wb-verschoben) und liegt ausserhalb von MainProduct. */
    if (typeof window.wbNachladen === 'function') {
      try { window.wbNachladen(null, daten.ziel); } catch (e) {}
    }

    /* Ohne diese Zeile stehen im Modus «Business» Bruttopreise — derselbe Fehler
       steckte bis 2026-08-18 in der Suchvorschau. */
    if (typeof window.changePrice === 'function' && typeof window.getStoredPriceOption === 'function') {
      window.changePrice(window.getStoredPriceOption());
    }

    wunschlisteNeuAnbinden(wurzelAlt);

    /* Material-Section(en) komplett durch die Fassung des Zielartikels ersetzen (statisches
       Markup ohne eigene Skripte, Bild/Video laden per src nach). */
    zusatzNeu.forEach(function (paar) {
      paar.alt.innerHTML = paar.neu.innerHTML;
    });

    if (bewertungenAlt && bewertungenRevamp) {
      revampErsetzen(bewertungenAlt, bewertungenRevamp, daten.revampKlasse, daten.produktId, daten.ziel);
      badgeSprungHerstellen(document.querySelector(BADGE_KAUFBOX));
    } else if (bewertungenAlt && bewertungenNeu) {
      bewertungenErsetzen(bewertungenAlt, bewertungenNeu, bewertungenEinrichtenNoetig, daten.ziel);
      badgeSprungHerstellen(document.querySelector(BADGE_KAUFBOX));
    }

    /* reviews.io-Bewertungssterne (2026-09-10): Die App befüllt ihre Snippets nur einmal je
       Seitenaufruf — nach dem Austausch blieb «(N Reviews)» in der Kaufbox leer, auch beim
       Zurückwechseln. Ihr Skript stellt aber reinitialiseRatingSnippet() bereit, das alle
       noch nicht befüllten Snippets per rating-batch nachfordert (gemessen: ein Aufruf,
       Snippet danach «(7 Reviews)»). Artikel ohne Bewertungen bleiben leer — wie beim
       direkten Aufruf. */
    bewertungenNachladen();

    if (mitHistorie) {
      window.history.pushState({ wbColorSwap: true }, '', daten.ziel);
    }
    if (daten.titel) document.title = daten.titel;

    /* Der Fokus lag auf einem Element, das es nicht mehr gibt. Für Tastatur- und
       Screenreader-Bedienung zurück auf den nun aktiven Farbpunkt. */
    var aktiv = document.querySelector('.crossseller-wrapper a[href^="' + daten.ziel + '"]');
    /* Fokus nur mit Zeigergerät: Auf Touch wertet WebKit den programmatischen Fokus nach
       einem Auswahlfeld-Wechsel als :focus-visible und malt Dawns Fokus-Ring als zweiten
       Ring um den aktiven Punkt («doppelt markiert», ATELLA 2026-09-17). */
    var mitZeiger = !(window.matchMedia && window.matchMedia('(hover: none)').matches);
    if (aktiv && mitZeiger && document.activeElement === document.body) aktiv.focus({ preventScroll: true });
    /* Rückmeldung am Handy: Der neue aktive Punkt zeigt seinen Namen kurz an. */
    tooltipKurzZeigen(aktiv);

    melden(daten.titel);
    /* 2026-10-07: Tooltips erst NACH dem ersten Malen ausrichten. Direkt nach dem Einsetzen erzwang das Messen
       (Klasse setzen, dann getBoundingClientRect) ein komplettes Layout des frischen DOMs — im CPU-Profil (Handy, 4×)
       rund 300–390 ms, der grösste JS-Posten des Wechsels. Zwei Frames später hat der Browser ohnehin gelayoutet,
       die Messung kostet dann nur die paar Tooltip-Elemente. Sichtbar wird davon nichts: Tooltips sind zu. */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(tooltipsAusrichten);
    });

    zeiten.parsen = Math.round(zeitGeparst - zeitStart);
    zeiten.einsetzen = Math.round(zeitEingesetzt - zeitGeparst);
    zeiten.skripte = Math.round(zeitSkripte - zeitEingesetzt);
    zeiten.rest = Math.round(performance.now() - zeitSkripte);
    zeiten.gesamt = Math.round(performance.now() - zeitStart);

    return true;
  }

  /* Die Auswahlfelder auf die tatsächlich geladene Variante stellen.

     Nötig wegen eines Fehlers im Theme: `snippets/product-variant-options.liquid`
     setzt `selected="selected"` über `option.selected_value == value`, und für die
     erste Option greift dieser Vergleich nicht — im gelieferten Markup fehlt das
     Attribut, worauf der Browser den ersten Eintrag der Liste anzeigt. Sichtbar wurde
     das als Widerspruch: Bild, Preis und Artikelnummer gehörten zur weissen
     Gestellfarbe, das Feld zeigte «Schwarz».

     Der Fehler steckt nicht im Farbwechsel — auch ein normaler Aufruf mit
     `?variant=…` zeigt die falsche Farbe (dort korrigiert sich das Theme selbst,
     indem es die Variante auf den angezeigten Wert umschreibt). Hier wird deshalb
     die Anzeige an die geladene Variante angeglichen, ohne ein `change`-Ereignis
     auszulösen — das würde einen weiteren Abruf starten. */
  function auswahlfelderAngleichen(variante) {
    if (!variante || !variante.options) return;

    var felder = document.querySelectorAll('variant-selects [data-option-name]');
    felder.forEach(function (feld, index) {
      var wert = variante.options[index];
      if (!wert || wert === 'Default') return;

      var select = feld.querySelector('select');
      if (select && select.value !== wert) select.value = wert;

      var radio = feld.querySelector('input[type="radio"][value="' + CSS.escape(wert) + '"]');
      if (radio && !radio.checked) radio.checked = true;

      /* Manche Felder zeigen den gewählten Wert zusätzlich in der Beschriftung. */
      var anzeige = feld.querySelector('[data-selected-swatch-value]');
      if (anzeige) anzeige.textContent = wert;
    });
  }

  /* Ankündigung für Screenreader. Bewusst nur der Produkttitel: Der ist bereits
     übersetzt, dadurch braucht das Skript keinen eigenen Text in vier Sprachen. */
  function melden(titel) {
    if (!titel) return;
    var region = document.getElementById('wb-color-swap-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'wb-color-swap-status';
      region.className = 'visually-hidden';
      region.setAttribute('aria-live', 'polite');
      region.setAttribute('role', 'status');
      document.body.appendChild(region);
    }
    region.textContent = titel;
  }

  /* Den Farbnamen-Tooltip im Fenster halten.

     Der Tooltip (snippets/wb-color-dot.liquid) wird über seinem Punkt zentriert.
     Beim ersten Punkt einer Reihe ragt er dadurch links aus dem Fenster, beim
     letzten rechts — sichtbar als «ubanitgrau» statt «Cubanitgrau». Reines CSS kann
     das nicht lösen: Der Tooltip kennt den Fensterrand nicht, und welcher Punkt in
     einer umbrechenden Reihe ganz links steht, hängt von der Fensterbreite ab.

     Deshalb wird hier gemessen. Jeder Tooltip wird kurz unsichtbar ins Layout geholt
     (`wb-tooltip--messen`), seine Lage mit dem Fenster verglichen und die nötige
     Verschiebung als `--wb-tooltip-shift` hinterlegt; das CSS im Snippet
     wb-color-swap rechnet sie in die Zentrierung ein und lässt die Pfeilspitze
     weiter auf den Punkt zeigen. Erst alle Klassen setzen, dann alle messen, dann
     alle entfernen — so rechnet der Browser das Layout einmal statt pro Punkt.

     Aufgerufen beim Start, nach jedem Farbwechsel (neue Punkte), nach dem Laden der
     Schriften (andere Textbreite) und bei geänderter Fensterbreite. Läuft auch auf
     pCon-Seiten, die vom Farbwechsel selbst ausgenommen sind. */
  var TOOLTIP_RAND = 8;

  /* Touch-Geräte: Tooltip kurz zeigen statt am Hover hängen zu lassen (2026-09-17).
     Setzt `wb-tooltip-an` am Punkt, räumt es bei allen anderen ab und entfernt es
     nach 1,5 s. Nur auf Geräten ohne Zeiger — am Desktop bleibt der echte Hover. */
  var tooltipTouchTimer = 0;
  function tooltipKurzZeigen(link) {
    if (!link || !window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.crossseller-wrapper a.wb-tooltip-an'), function (a) {
      if (a !== link) a.classList.remove('wb-tooltip-an');
    });
    link.classList.add('wb-tooltip-an');
    tooltipsAusrichten();
    /* 2026-10-09 (Nutzer: «die Sprechblase ist oberhalb des Bildes bei mobile, also überlagert es»): Klebt das
       Hauptbild gerade oben (sections/main-product.liquid, .wb-bild-fixiert, z 6) und steht der Punkt knapp
       darunter, ragt die Blase (z 100) in den Kasten und liegt ÜBER dem Bild. Dann unter den Punkt klappen
       (CSS wb-tooltip-unten in snippets/wb-color-swap.liquid). */
    link.classList.remove('wb-tooltip-unten');
    var kasten = document.querySelector('.wb-bild-fixiert');
    var blase = link.querySelector('.b-tooltip');
    if (kasten && blase && blase.getBoundingClientRect().top < kasten.getBoundingClientRect().bottom) {
      link.classList.add('wb-tooltip-unten');
    }
    window.clearTimeout(tooltipTouchTimer);
    tooltipTouchTimer = window.setTimeout(function () {
      link.classList.remove('wb-tooltip-an');
      link.classList.remove('wb-tooltip-unten');
    }, 1500);
  }

  function tooltipsAusrichten() {
    var tooltips = Array.from(document.querySelectorAll('.crossseller-wrapper .b-tooltip'));
    if (!tooltips.length) return;

    tooltips.forEach(function (tooltip) {
      tooltip.style.setProperty('--wb-tooltip-shift', '0px');
      tooltip.classList.add('wb-tooltip--messen');
    });

    var fensterBreite = document.documentElement.clientWidth;
    var verschiebungen = tooltips.map(function (tooltip) {
      var lage = tooltip.getBoundingClientRect();
      if (lage.width === 0) return 0;
      if (lage.left < TOOLTIP_RAND) return TOOLTIP_RAND - lage.left;
      if (lage.right > fensterBreite - TOOLTIP_RAND) return fensterBreite - TOOLTIP_RAND - lage.right;
      return 0;
    });

    tooltips.forEach(function (tooltip, i) {
      tooltip.style.setProperty('--wb-tooltip-shift', Math.round(verschiebungen[i]) + 'px');
      tooltip.classList.remove('wb-tooltip--messen');
    });
  }

  var tooltipTimer = null;
  function tooltipsSpaeterAusrichten() {
    if (tooltipTimer) window.clearTimeout(tooltipTimer);
    tooltipTimer = window.setTimeout(tooltipsAusrichten, 150);
  }

  /* Die Klasse sitzt an der Section und nicht an `.product`: Letzteres wird beim
     Austausch selbst ersetzt und verlöre die Markierung mitten im Vorgang. */
  function ladeanzeige(an, bildDa) {
    var wurzel = document.querySelector('[id^="' + SECTION_PRAEFIX + '"]');
    if (!wurzel) return;
    wurzel.classList.toggle('wb-color-swap--laedt', an);
    /* 2026-10-19: Steht das neue Bild schon (sofortBild), soll die Galerie am Desktop nicht darüber dimmen
       (CSS in snippets/wb-color-swap.liquid). */
    wurzel.classList.toggle('wb-color-swap--bild-da', !!(an && bildDa));
  }

  /* Die für den Zielartikel gerenderte Widget-Section aus dem Abruf lesen. Gültig ist
     sie nur mit genau EINEM Widget, dessen `data-id` die Produkt-ID des Zielartikels
     trägt (aus /products/<handle>.js) — sonst null. */
  function bewertungenNeuLesen(daten, sectionDomId) {
    if (!daten.bewertungenHtml || bewertungenNichtTauschbar()) return null;
    var dokument = new DOMParser().parseFromString(daten.bewertungenHtml, 'text/html');
    var section = dokument.getElementById(sectionDomId);
    if (!section) return null;
    var widgets = section.querySelectorAll(JDGM_WIDGET);
    if (widgets.length !== 1) return null;
    if (!daten.produktId || widgets[0].getAttribute('data-id') !== String(daten.produktId)) return null;
    if (!istLegacyWidget(section)) return null;
    return section;
  }

  /* Ersetzt den GESAMTEN Inhalt der Widget-Section — das alte Widget (samt allem, was
     Judge.me hineingeschrieben hat: Sortierung, Formular, nachgeladene Seiten)
     verschwindet vollständig, es bleibt genau ein Widget des Zielartikels.

     Danach richtet Judge.me das neue Widget ein. Verwendet wird ausschliesslich, was
     das im Theme geladene Judge.me-Skript (App-Embed, loader.js + widget/common.js)
     nachweislich bereitstellt — gelesen und im Preview gemessen am 2026-09-18:

     1. `.jdgm-legacy-widget-content` kommt mit `display: none` vom Server; beim
        Seitenstart blendet der Loader sie ein und entfernt `.jdgm-ssr-reviews`.
        Genau das wird hier nachvollzogen.
     2. `jdgm.initializeWidgets()` richtet alle Widgets OHNE die Klasse
        `jdgm--done-setup-widget` ein (Titel, Histogramm, Sortierung, Paginierung,
        Datumsformat, Formular) — das frisch eingesetzte Widget trägt sie nicht.
     3. Die Funktion ruft Teile aus `widget/media.js` und `widget/form.js` auf. Judge.me
        lädt diese Module beim Seitenstart nur bei Bedarf; fehlen sie, bricht
        `initializeWidgets` ab (gemessen: «setupMediaGallery is not a function»).
        Deshalb werden sie vorher über Judge.mes eigenen `jdgm.loadScript` angefordert
        (lädt jede Datei höchstens einmal) und es wird gewartet, bis sie bereitstehen.

     Scheitert irgendein Schritt (Modul lädt nicht binnen JDGM_WARTEZEIT, Ausnahme in
     initializeWidgets, Klasse `jdgm--done-setup-widget` fehlt danach), wird die Adresse
     des Zielartikels normal geladen — siehe bewertungenRueckfall. */
  var JDGM_MODULE = ['widget/media.js', 'widget/form.js'];
  var JDGM_FUNKTIONEN = ['setupMediaGallery', '_renderAndSetupReviewForm', '_setupQuestionsForm', '_setupFormsSubmit'];

  /* Rückfall NACH dem DOM-Tausch: Scheitert das Einrichten aus irgendeinem Grund, wird die
     (bereits bekannte) Adresse des Zielartikels normal geladen — die Seite bleibt nie in
     einem halb ausgetauschten Zustand stehen. Nur solange dieses Widget noch das aktuelle
     ist: Wurde inzwischen weitergewechselt, kümmert sich der neuere Durchlauf. */
  function bewertungenRueckfall(widget, zielUrl) {
    if (!document.documentElement.contains(widget)) return;
    window.location.href = zielUrl;
  }

  function bewertungenErsetzen(sectionAlt, sectionNeu, einrichtenNoetig, zielUrl) {
    var widget = null;
    try {
      while (sectionAlt.firstChild) sectionAlt.removeChild(sectionAlt.firstChild);
      Array.prototype.slice.call(sectionNeu.childNodes).forEach(function (knoten) {
        sectionAlt.appendChild(document.importNode(knoten, true));
      });

      widget = sectionAlt.querySelector(JDGM_WIDGET);
      if (!widget) throw new Error('Widget fehlt nach dem Tausch');

      /* Judge.me läuft auf dieser Seite nicht — das Server-Markup bleibt wie bei einem
         normalen Seitenaufruf stehen (siehe jdgmLaeuft). */
      if (!einrichtenNoetig) return;

      var legacy = widget.querySelector('.jdgm-legacy-widget-content');
      if (legacy) legacy.style.display = '';
      var ssr = widget.querySelector('.jdgm-ssr-reviews');
      if (ssr) ssr.parentNode.removeChild(ssr);
    } catch (e) {
      /* Die Section ist womöglich schon geleert — nicht so stehen lassen. */
      window.location.href = zielUrl;
      return;
    }

    bewertungenEinrichten(widget, zielUrl);
  }

  var JDGM_WARTEZEIT = 5000;

  function bewertungenEinrichten(widget, zielUrl) {
    var jdgm = window.jdgm;

    function bereit() {
      return JDGM_FUNKTIONEN.every(function (name) {
        return typeof jdgm[name] === 'function';
      });
    }

    function einrichten() {
      /* Inzwischen wurde weitergewechselt: Dieses Widget steht nicht mehr im Dokument,
         das aktuelle richtet sein eigener Durchlauf ein. */
      if (!document.documentElement.contains(widget)) return;
      try {
        /* Draft-Test 2026-09-18: Ohne diese beiden Daten fehlte nach dem Wechsel das
           Sortier-Dropdown. Judge.me setzt sie beim Seitenstart nur an den damals
           vorhandenen Widgets (jdgm.eachWidgetWithReviews über jdgm.caches); ohne
           `class-prefix` findet `customizeWidgetSort` den Review-Body nicht und verwirft
           den Sortier-Wrapper. Gleiche Werte wie dort, über Judge.mes eigenes jQuery
           und `jdgm.getWidgetPrefix`. */
        var $widget = jdgm.$(widget);
        if (!$widget.data('unique-string')) {
          $widget.data('unique-string', Date.now().toString(36) + '-wb');
          $widget.data('class-prefix', jdgm.getWidgetPrefix($widget));
        }
        jdgm.initializeWidgets();
      } catch (e) {
        bewertungenRueckfall(widget, zielUrl);
        return;
      }
      /* Erfolg heisst: Judge.me hat das Widget als eingerichtet markiert … */
      if (!widget.classList.contains('jdgm--done-setup-widget')) {
        bewertungenRueckfall(widget, zielUrl);
        return;
      }
      /* «Bewertung schreiben» einblenden (2026-09-18, Regression nach dem Wechsel): Der
         Server liefert den Link IMMER mit `style="display: none"`. Eingeblendet wird er
         von widget/form.js — aber nur EINMAL, in dem Moment, in dem das Modul lädt, und
         nur für die dann vorhandenen Links. Ein später eingesetztes Widget behielt sein
         `display: none`; `initializeWidgets()` übersetzt den Text, blendet aber nicht ein.
         Hier deshalb dieselbe Regel wie in form.js, begrenzt auf dieses Widget:
         sichtbar, wenn Web-Bewertungen nicht abgeschaltet sind UND Judge.mes
         Kundenkonto-Regel (write_review_button_visibility) es erlaubt — sonst bleibt
         er, wie von Judge.me vorgesehen, verborgen. */
      try {
        var einstellungen = window.jdgmSettings || {};
        var erlaubt =
          !einstellungen.disable_web_reviews &&
          (typeof jdgm.checkCustomerAccountRestriction !== 'function' || jdgm.checkCustomerAccountRestriction());
        var $links = jdgm.$(widget).find('.jdgm-write-rev-link');
        if (erlaubt) $links.show();
        else $links.hide();
        jdgm.$(widget).find('.jdgm-ask-question-btn').show();
      } catch (e) {
        bewertungenRueckfall(widget, zielUrl);
        return;
      }
      /* … und bei einem Artikel MIT Bewertungen steht danach das Sortier-Dropdown
         (Judge.me setzt es per setTimeout ein). Fehlt es, ist das Widget nur halb
         eingerichtet → normale Navigation. */
      var kern = widget.querySelector('.jdgm-rev-widg');
      if (kern && parseInt(kern.getAttribute('data-number-of-reviews'), 10) > 0) {
        window.setTimeout(function () {
          if (!widget.querySelector('.jdgm-rev-widg__sort-wrapper select.jdgm-sort-dropdown')) {
            bewertungenRueckfall(widget, zielUrl);
          }
        }, 1000);
      }
    }

    if (bereit()) {
      einrichten();
      return;
    }

    try {
      JDGM_MODULE.forEach(function (modul) {
        jdgm.loadScript(jdgm.CDN_HOST + modul);
      });
    } catch (e) {
      bewertungenRueckfall(widget, zielUrl);
      return;
    }

    /* Der Lade-Callback von Judge.me feuert, bevor das Modul seine Funktionen
       angelegt hat (gemessen) — deshalb auf die Funktionen selbst warten. */
    var start = performance.now();
    (function warten() {
      if (!document.documentElement.contains(widget)) return;
      if (bereit()) {
        einrichten();
        return;
      }
      if (performance.now() - start > JDGM_WARTEZEIT) {
        bewertungenRueckfall(widget, zielUrl);
        return;
      }
      window.setTimeout(warten, 50);
    })();
  }

  /* Judge.me «Widget 3.0» (Revamp, Vue) nach dem Farbwechsel — 2026-09-30.

     So startet Judge.me es beim Seitenaufruf (judgeme-770, gelesen am 2026-09-30):
     Die Widget-Section bringt ein Inline-Skript mit, das die Bewertungsdaten ablegt
     (jdgm.data.reviewWidget[<Produkt-ID>] = {…}); loader.js lädt deshalb das Modul
     review_widget.js, und das erzeugt je Widget einen ReviewWidgetManager
     (`new ReviewWidgetManager(container).initialize()`), der die Daten liest, den
     Container leert und die Vue-App hineinhängt. Das Modul startet nur einmal je Seite
     und hält seine Liste privat — die Klasse selbst exportiert es aber.

     Nach dem Tausch passiert dasselbe von Hand: Daten des Zielartikels aus dem
     Inline-Skript lesen (JSON.parse, kein eval), ablegen, Markup einsetzen, Judge.mes
     eigene Klasse starten. Die Klasse kommt aus DEMSELBEN, von der Seite bereits
     geladenen Modul (gleiche Adresse → gleiche Modul-Instanz, kein zweiter Download).
     Scheitert irgendetwas, lädt die Zielseite normal (bewertungenRueckfall). */
  var REVAMP_MODUL = /\/ReviewWidgetManager-[\w-]+\.js(\?|$)/;
  var REVAMP_WURZEL = '.jm-review-widget';
  var REVAMP_WARTEZEIT = 8000;
  var revampKlasseVersprechen = null;

  function revampKlasseLaden() {
    if (revampKlasseVersprechen) return revampKlasseVersprechen;
    var adresse = null;
    try {
      var eintraege = performance.getEntriesByType('resource');
      for (var i = 0; i < eintraege.length; i++) {
        if (REVAMP_MODUL.test(eintraege[i].name)) {
          adresse = eintraege[i].name;
          break;
        }
      }
    } catch (e) {
      adresse = null;
    }
    /* Modul (noch) nicht geladen — nicht merken, beim nächsten Überfahren neu suchen. */
    if (!adresse) return Promise.resolve(null);
    /* Bewusst KEIN import(): Shopify verkleinert Theme-JS beim Ausliefern und schreibt
       import(x) dabei zu require(x) um (gemessen 2026-09-30) — das gibt es im Browser
       nicht. Ein Modul-Skript mit festem Text übersteht die Verkleinerung und holt die
       Klasse aus derselben, bereits geladenen Modul-Instanz. */
    revampKlasseVersprechen = new Promise(function (fertig) {
      if (typeof window.wbJdgmWidgetKlasse === 'function') {
        fertig(window.wbJdgmWidgetKlasse);
        return;
      }
      var erledigt = false;
      function ende(klasse) {
        if (erledigt) return;
        erledigt = true;
        document.removeEventListener('wb:jdgm-widget-klasse', beiKlasse);
        if (!klasse) revampKlasseVersprechen = null;
        fertig(klasse);
      }
      function beiKlasse() {
        ende(typeof window.wbJdgmWidgetKlasse === 'function' ? window.wbJdgmWidgetKlasse : null);
      }
      document.addEventListener('wb:jdgm-widget-klasse', beiKlasse);
      window.setTimeout(function () {
        ende(null);
      }, 5000);
      var skript = document.createElement('script');
      skript.type = 'module';
      skript.onerror = function () {
        ende(null);
      };
      skript.textContent =
        'import { ReviewWidgetManager } from ' +
        JSON.stringify(adresse) +
        '; window.wbJdgmWidgetKlasse = ReviewWidgetManager; document.dispatchEvent(new Event("wb:jdgm-widget-klasse"));';
      document.head.appendChild(skript);
    });
    return revampKlasseVersprechen;
  }

  var REVAMP_DATEN = /^\s*jdgm\.data\s*\|\|=\s*\{\}\s*;\s*jdgm\.data\.reviewWidget\s*\|\|=\s*\{\}\s*;\s*jdgm\.data\.reviewWidget\[(\d+)\]\s*=\s*(\{[\s\S]*\})\s*;?\s*$/;

  /* Widget-Section des Zielartikels für Widget 3.0 lesen. Gültig nur, wenn Judge.me sie
     beim normalen Aufruf ebenfalls als Widget 3.0 starten würde: genau EIN Widget mit
     der Produkt-ID des Ziels, höchstens EIN Datenskript in der bekannten Form für genau
     diese ID, sonst höchstens JSON-LD. Alles andere → null (normale Navigation).

     2026-10-26 (Nutzer: «bei Linoleum Pebble lädt die ganze Seite neu»): Artikel OHNE
     Bewertungen bekommen von Judge.me KEIN Datenskript, nur das leere Widget
     (data-empty-state) — der Loader startet dort trotzdem die Revamp-Fassung, weil kein
     klassischer Inhalt vorliegt, und das Widget zeigt «Schreiben Sie die erste
     Bewertung». Bis dahin erzwang diese Funktion ein Datenskript, sodass jeder Wechsel
     AUF einen Artikel ohne Bewertungen die ganze Seite lud. Jetzt gilt ein Ziel ohne
     Datenskript als gültig, sofern das Widget auch keinen klassischen Inhalt trägt
     (dieselbe Regel wie wbRevampAktiv); revampErsetzen trägt dann ein leeres Objekt als
     Datensatz ein, damit das Widget wie beim Seitenaufruf leer startet. */
  function revampLesen(daten, sectionDomId) {
    if (!daten.bewertungenHtml || !daten.revampKlasse || !daten.produktId) return null;
    var einstellungen = window.jdgmSettings;
    if (!einstellungen || !einstellungen.review_widget_revamp_enabled) return null;
    var dokument = new DOMParser().parseFromString(daten.bewertungenHtml, 'text/html');
    var section = dokument.getElementById(sectionDomId);
    if (!section) return null;
    var widgets = section.querySelectorAll(JDGM_WIDGET);
    if (widgets.length !== 1) return null;
    if (widgets[0].getAttribute('data-id') !== String(daten.produktId)) return null;
    if (!widgets[0].getAttribute('data-entry-point')) return null;
    var werte = null;
    var skripte = Array.prototype.slice.call(section.querySelectorAll('script'));
    for (var i = 0; i < skripte.length; i++) {
      var typ = (skripte[i].getAttribute('type') || '').toLowerCase();
      if (typ === 'application/ld+json') continue;
      if (typ && typ !== 'text/javascript') return null;
      if (werte) return null;
      var treffer = REVAMP_DATEN.exec(skripte[i].textContent);
      if (!treffer || treffer[1] !== String(daten.produktId)) return null;
      try {
        werte = JSON.parse(treffer[2]);
      } catch (e) {
        return null;
      }
      if (!werte || typeof werte !== 'object') return null;
      skripte[i].parentNode.removeChild(skripte[i]);
    }
    if (!werte) {
      /* Kein Datenskript: nur gültig, wenn Judge.me hier auch beim normalen Aufruf
         die Revamp-Fassung (leeres Widget) startet, d. h. kein klassischer Inhalt. */
      var legacy = widgets[0].querySelector('.jdgm-legacy-widget-content');
      if (legacy && legacy.innerHTML.trim().length > 20) return null;
    }
    return { section: section, werte: werte };
  }

  function revampErsetzen(sectionAlt, neu, Klasse, produktId, zielUrl) {
    var widget = null;
    try {
      /* Alte Vue-App sauber abbauen (Vue 3 hängt sie als __vue_app__ an den Container),
         sonst liefen ihre Beobachter und Handler weiter. */
      var widgetAlt = sectionAlt.querySelector(JDGM_WIDGET);
      var app = widgetAlt && widgetAlt.__vue_app__;
      if (app && typeof app.unmount === 'function') {
        try {
          app.unmount();
        } catch (e) {
          /* Abbau gescheitert — der Container wird gleich ohnehin entfernt. */
        }
      }
      var jdgm = window.jdgm;
      jdgm.data = jdgm.data || {};
      jdgm.data.reviewWidget = jdgm.data.reviewWidget || {};
      /* Ziel ohne Bewertungen (kein Datenskript): leeres Objekt eintragen. Judge.mes
         getReviewDataFromJdgm() (ReviewWidgetManager, judgeme-822) liefert beim
         Seitenaufruf ohne jeden Datensatz {} und zeigt damit den Leerzustand; gibt es
         jdgm.data.reviewWidget aber schon (vom vorigen Artikel), liest es den Eintrag
         der Ziel-ID und stürzt bei undefined in initialize() ab («sort_key»). Nie
         fremde Daten stehen lassen. */
      jdgm.data.reviewWidget[produktId] = neu.werte || {};

      while (sectionAlt.firstChild) sectionAlt.removeChild(sectionAlt.firstChild);
      Array.prototype.slice.call(neu.section.childNodes).forEach(function (knoten) {
        sectionAlt.appendChild(document.importNode(knoten, true));
      });
      widget = sectionAlt.querySelector(JDGM_WIDGET);
      if (!widget) throw new Error('Widget fehlt nach dem Tausch');
      /* Wie loader.js vor dem Start: klassischen Kern ausblenden, SSR-Bewertungen weg. */
      var kern = widget.querySelector('.jdgm-rev-widg');
      if (kern) kern.style.display = 'none';
      var ssr = widget.querySelector('.jdgm-ssr-reviews');
      if (ssr) ssr.parentNode.removeChild(ssr);
    } catch (e) {
      window.location.href = zielUrl;
      return;
    }

    var start = performance.now();
    function pruefen() {
      if (!document.documentElement.contains(widget)) return;
      if (widget.querySelector(REVAMP_WURZEL)) {
        /* Wie beim Seitenaufruf (dort setzt es widget_common.js): als eingerichtet
           markieren, damit Judge.mes klassische initializeWidgets es nicht anfasst. */
        widget.classList.add('jdgm--done-setup-widget');
        return;
      }
      if (performance.now() - start > REVAMP_WARTEZEIT) {
        bewertungenRueckfall(widget, zielUrl);
        return;
      }
      window.setTimeout(pruefen, 100);
    }
    try {
      Promise.resolve(new Klasse(widget).initialize()).then(pruefen, function () {
        bewertungenRueckfall(widget, zielUrl);
      });
    } catch (e) {
      bewertungenRueckfall(widget, zielUrl);
    }
  }

  function bewertungenNachladen() {
    try {
      if (typeof window.reinitialiseRatingSnippet === 'function') window.reinitialiseRatingSnippet();
    } catch (e) {
      /* Fremd-App — ein Fehler dort darf den Wechsel nicht stören. */
    }
  }

  /* Sprung vom Sterne-Badge der Kaufbox zum Widget nach einem Wechsel (2026-09-28).

     Judge.me entscheidet beim Einrichten eines Preview-Badges EINMAL, ob ein Klick zum
     Widget springt: Es vergleicht die `data-id` des Badges mit dem Widget aus
     `jdgm.caches.$revWidgets` — einer Liste, die Judge.me nur beim Seitenstart anlegt
     (widget_common.js, gelesen am 2026-09-28). Nach unserem Tausch zeigt sie weiter auf
     das entfernte Widget des zuerst geladenen Artikels. Für jeden anderen Artikel fällt
     der Vergleich negativ aus: Der Klick bleibt wirkungslos, und Judge.me macht die
     Sterne zum Bild (role="img", ohne tabindex) — per Tastatur nicht mehr erreichbar.
     Zurück beim Ausgangsartikel stimmt der Vergleich wieder, deshalb ging es dort.

     Judge.mes Cache bleibt unangetastet. Stattdessen gibt `badgeSprungHerstellen` einem
     so eingerichteten Badge dieselben Attribute, die Judge.me verlinkten Badges gibt, und
     markiert es; die Handler in `start` springen bei markierten Badges zum Widget, dessen
     `data-id` zum Badge passt — gelesen im Moment des Klicks, also immer der angezeigte
     Artikel. Unmarkierte Badges (Seitenstart, Ausgangsartikel) bedient weiter Judge.me. */
  var BADGE_KAUFBOX = '.product__info-container .jdgm-preview-badge';
  var BADGE_MARKE = 'data-wb-badge-sprung';

  function widgetFuerBadge(badge) {
    var id = badge.getAttribute('data-id');
    if (!id) return null;
    var widgets = document.querySelectorAll(JDGM_WIDGET);
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].getAttribute('data-id') === id) return widgets[i];
    }
    return null;
  }

  var sprungNummer = 0;

  function zumWidgetSpringen(widget) {
    var meineNummer = ++sprungNummer;
    /* Gleicher Abstand wie Judge.mes eigener Sprung (jdgmSettings.scrollTopOffset, im Shop
       30 px); ein dauerhaft klebender Header kommt hinzu. Der Header ist derzeit nicht
       klebend (sticky_header_type «none»), die Abfrage greift erst, wenn sich das ändert. */
    var einstellungen = window.jdgmSettings || {};
    var abstand = typeof einstellungen.scrollTopOffset === 'number' ? einstellungen.scrollTopOffset : 30;
    var kopf = document.querySelector(
      'sticky-header[data-sticky-type="always"], sticky-header[data-sticky-type="reduce-logo-size"]',
    );
    if (kopf) abstand += kopf.getBoundingClientRect().height;
    var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function scrollen() {
      window.scrollTo({
        top: Math.max(0, widget.getBoundingClientRect().top + window.pageYOffset - abstand),
        behavior: ruhig ? 'auto' : 'smooth',
      });
    }

    /* Über dem Widget stehen verzögert geladene Cross-Seller (apps-Sections mit
       wb_spaeter_laden): Sie werden erst beim Vorbeiscrollen eingesetzt und schieben das
       Widget danach nach unten (gemessen 2026-09-28: Ziel um rund 570 px verfehlt). Deshalb
       nachmessen und höchstens viermal nachsteuern. Schluss, sobald der Nutzer selbst
       scrollt oder ein neuer Sprung beginnt. */
    var ereignisse = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    var korrekturen = 0;
    var abgebrochen = false;
    var angemeldet = false;
    function abbrechen() {
      abgebrochen = true;
      aufraeumen();
    }
    function aufraeumen() {
      window.clearTimeout(anmeldung);
      if (!angemeldet) return;
      angemeldet = false;
      ereignisse.forEach(function (art) {
        window.removeEventListener(art, abbrechen, { passive: true });
      });
    }
    /* Erst im nächsten Tick anmelden: Kommt der Sprung per Enter/Leertaste, läuft dieses
       keydown noch bis `window` weiter und würde einen jetzt angemeldeten Listener sofort
       auslösen (gemessen 2026-09-28) — die Nachsteuerung wäre dann nie aktiv. */
    var anmeldung = window.setTimeout(function () {
      if (abgebrochen || meineNummer !== sprungNummer) return;
      angemeldet = true;
      ereignisse.forEach(function (art) {
        window.addEventListener(art, abbrechen, { passive: true });
      });
    }, 0);

    scrollen();
    (function nachmessen() {
      window.setTimeout(function () {
        if (abgebrochen || meineNummer !== sprungNummer || !document.documentElement.contains(widget)) {
          aufraeumen();
          return;
        }
        if (Math.abs(widget.getBoundingClientRect().top - abstand) > 2 && korrekturen < 4) {
          korrekturen += 1;
          scrollen();
          nachmessen();
          return;
        }
        aufraeumen();
      }, 600);
    })();
  }

  /* Judge.me richtet das neue Badge asynchron ein (jdgm.customizeBadges über asyncEach) —
     deshalb auf `jdgm--done-setup` warten, sonst überschriebe es unsere Attribute. Wird
     inzwischen weitergewechselt, verschwindet das Badge aus dem Dokument und dieser
     Durchlauf endet; das neue Badge hat seinen eigenen. */
  function badgeSprungHerstellen(badge) {
    if (!badge) return;
    var start = performance.now();
    (function warten() {
      if (!document.documentElement.contains(badge)) return;
      if (!badge.classList.contains('jdgm--done-setup')) {
        if (performance.now() - start < JDGM_WARTEZEIT) window.setTimeout(warten, 50);
        return;
      }
      /* Judge.me hat den Sprung selbst eingerichtet (Ausgangsartikel) → nichts zu tun. */
      if (badge.classList.contains('jdgm-preview-badge--with-link')) return;
      var sterne = badge.querySelector('.jdgm-prev-badge__stars');
      if (!sterne || !widgetFuerBadge(badge)) return;
      var einstellungen = window.jdgmSettings || {};
      sterne.setAttribute('role', 'button');
      sterne.setAttribute('tabindex', '0');
      sterne.setAttribute('aria-label', einstellungen.widget_rating_filter_see_all_text || 'See all reviews');
      badge.classList.add('jdgm-preview-badge--with-link');
      badge.setAttribute(BADGE_MARKE, '');
    })();
  }

  function wechseln(zielUrl, sid, mitHistorie) {
    laufendeNummer += 1;
    var meineNummer = laufendeNummer;
    /* 2026-10-19: Zuerst das Bild (sofortBild); ist es gesetzt, dimmt die Galerie am Desktop nicht mehr. */
    var bildGesetzt = sofortBild(zielUrl.split('?')[0]);
    ladeanzeige(true, bildGesetzt);

    return vorbereiten(zielUrl, sid, true)
      .then(function (daten) {
        if (meineNummer !== laufendeNummer) return null;
        if (!bildGesetzt) return daten;
        /* Dem Browser einen Frame für das neue Bild lassen — der Tausch darunter blockiert 350–470 ms. */
        return new Promise(function (weiter) {
          nachDemMalen(function () {
            weiter(daten);
          });
        });
      })
      .then(function (daten) {
        /* Zwischenzeitlich wurde eine andere Farbe angeklickt — diese Antwort ist
           überholt und darf nichts mehr anfassen. */
        if (!daten || meineNummer !== laufendeNummer) return;

        /* 2026-10-09: Ein Zwischenstand wartete hier bis 1,5 s auf das dekodierte Hauptbild (Text und Bild im selben
           Frame) — auf Nutzerwunsch wieder raus («kann man das nicht wieder so wie vorher machen?»): sofort tauschen.
           Das Hauptbild ist durch hauptbildVorladen (ab pointerdown/Klick) meist ohnehin schon da. */
        var erfolg = ausfuehren(daten, sid, mitHistorie);
        ladeanzeige(false);
        if (!erfolg) window.location.href = zielUrl;
      })
      .catch(function () {
        if (meineNummer !== laufendeNummer) return;

        /* Netzwerkfehler, fremdes Template (404) oder unerwartetes Markup:
           Der Kunde merkt davon nichts, es wird einfach normal navigiert. */
        ladeanzeige(false);
        window.location.href = zielUrl;
      });
  }

  /* 2026-10-01 (Nutzer: «Farbwechsel am Handy dauert länger»): Gemessen ART mobil 2,3 s bis
     zur Anzeige. Judge.me war es nicht (Review-Section 130–150 ms, parallel), sondern das
     Rendern der Produkt-Section durch Shopify (1,2–1,5 s, rund 325 KB). Am Handy startete der
     Abruf erst beim Antippen, am Desktop beim Überfahren (~0,3 s Vorsprung).
     Jetzt werden die übrigen Farben NACHGELAGERT vorgeladen: erst nach dem load-Ereignis,
     erst wenn die Farbpunkte (fast) im Bild sind, jeweils im Leerlauf des Browsers und
     nacheinander statt gleichzeitig, höchstens VORLADEN_MAX Farben. Nicht bei Datensparmodus
     oder 2G/3G. Es wird nur Text abgeholt und gemerkt — eingesetzt wird erst beim Klick,
     der Hauptthread bleibt bis dahin unbelastet. */
  /* 2026-10-07 (Nutzer «alles umsetzen was geht»): alle Farben statt drei — Shopifys Section-Render (0,5–1,5 s) ist der
     grösste Posten des Wechsels; vorgeladen bleibt nur die Rechenzeit (Desktop ~0,25 s). Weiterhin nacheinander, im
     Leerlauf, erst wenn die Punkte im Bild sind, nicht bei Datensparmodus/2G/3G; je Farbe ~60 KB komprimiert. */
  var VORLADEN_MAX = 20;

  function vorladenImLeerlauf(sid) {
    var netz = navigator.connection;
    if (netz && (netz.saveData || /2g|3g/.test(netz.effectiveType || ''))) return;
    if (!('IntersectionObserver' in window)) return;

    var leerlauf = window.requestIdleCallback
      ? function (fn) {
          window.requestIdleCallback(fn, { timeout: 3000 });
        }
      : function (fn) {
          /* 2026-10-21: Safari hat kein requestIdleCallback — mit 500 ms Pause je Farbe brauchte die Kette am iPhone
             ~10 s für acht Farben (gemessen), wer vorher tippte, wartete auf den Server (Nutzer: «hängt jetzt mehr»).
             Die Kette startet ohnehin erst nach load, wenn die Punkte im Bild sind; 50 ms reichen als Atempause. */
          window.setTimeout(fn, 50);
        };
    /* 2026-10-21: Zwei Farben gleichzeitig statt eine — der grösste Posten je Farbe ist Shopifys Section-Render
       (kalt 0,8–1,1 s), der Hauptthread ist dabei frei. Gemessen WebKit: acht Farben in ~4 s statt ~10 s. */
    var PARALLEL = 2;
    var gestartet = false;

    function los() {
      if (gestartet) return;
      gestartet = true;
      var aktuell = window.location.pathname;
      var urls = [];
      Array.prototype.forEach.call(document.querySelectorAll('.crossseller-wrapper a[href]'), function (a) {
        var url = a.getAttribute('href');
        if (!url || url.split('?')[0] === aktuell || urls.indexOf(url) !== -1) return;
        urls.push(url);
      });
      urls = urls.slice(0, VORLADEN_MAX);
      /* 2026-10-19: Die Startfarbe zuletzt mitholen — nach einem Wechsel war sie sonst die einzige nicht vorgeladene
         Farbe (Zurückklicken: 1,2–1,5 s Section-Render statt sofort). */
      if (urls.length) urls.push(aktuell);
      function naechste() {
        var url = urls.shift();
        if (!url) return;
        leerlauf(function () {
          vorbereiten(url, sid)
            .catch(function () {
              /* Scheitert das Vorladen, versucht es der Klick erneut. */
            })
            .then(naechste);
        });
      }
      for (var k = 0; k < PARALLEL; k++) naechste();
    }

    function beobachten() {
      var reihen = document.querySelectorAll('.crossseller-wrapper');
      if (!reihen.length) return;
      var beobachter = new IntersectionObserver(
        function (eintraege) {
          if (!eintraege.some(function (e) { return e.isIntersecting; })) return;
          beobachter.disconnect();
          leerlauf(los);
        },
        { rootMargin: '200px 0px' },
      );
      Array.prototype.forEach.call(reihen, function (r) {
        beobachter.observe(r);
      });
    }

    if (document.readyState === 'complete') beobachten();
    else window.addEventListener('load', beobachten, { once: true });
  }

  function farbpunktAus(ereignis) {
    var ziel = ereignis.target;
    var link = ziel && ziel.closest ? ziel.closest('.crossseller-wrapper a[href]') : null;
    return link;
  }

  function einfacherKlick(ereignis) {
    return (
      ereignis.button === 0 &&
      !ereignis.metaKey &&
      !ereignis.ctrlKey &&
      !ereignis.shiftKey &&
      !ereignis.altKey
    );
  }

  function start() {
    var sid = sectionId();
    if (!sid || istPconSeite(sid)) return;

    /* Vorabladen, sobald sich Interesse abzeichnet. Zwischen Überfahren und Klick
       liegen typisch 200–400 ms; der Abruf dauert rund 600 ms und ist damit beim
       Loslassen meist fertig. Auf Touch-Geräten übernimmt das pointerdown. */
    ['pointerenter', 'pointerdown'].forEach(function (art) {
      document.addEventListener(
        art,
        function (ereignis) {
          var link = farbpunktAus(ereignis);
          if (!link) return;
          if (art === 'pointerdown' && ereignis.pointerType === 'touch') tooltipKurzZeigen(link);
          var url = link.getAttribute('href');
          if (!url || url === window.location.pathname) return;
          vorbereiten(url, sid, true).catch(function () {
            /* Scheitert das Vorabladen, versucht es der Klick erneut. */
          });
        },
        true,
      );
    });

    vorladenImLeerlauf(sid);

    /* 2026-10-19: Startfarbe in den Bild-Vorrat (sofortBild beim Zurückklicken, bevor das Leerlauf-Vorladen sie hat).
       Das Element wird beim Tausch entfernt, seine Attribute bleiben lesbar. */
    var startBild = document.querySelector('[id^="main-swiper-"] .swiper-slide img');
    if (startBild) bildFuerPfad[window.location.pathname] = { fertig: true, bild: startBild };

    /* 2026-09-10: Schnittstelle für die Pseudo-Grössenwahl (snippets/wb-groessen-wahl.liquid) —
       derselbe Section-Austausch, dieselben Rückfälle. */
    window.wbColorSwap = {
      wechseln: function (url) {
        return wechseln(url, sid, true);
      },
      vorbereiten: function (url) {
        return vorbereiten(url, sid, true).catch(function () {});
      },
    };

    /* Badge-Sprung nach einem Wechsel (siehe badgeSprungHerstellen). Nur echte Klicks:
       Judge.mes Tastatur-Handler löst beim Loslassen von Enter/Leertaste zusätzlich einen
       programmatischen Klick aus (isTrusted false) — der Sprung kommt dann schon vom
       keydown unten und soll nicht zweimal starten. */
    document.addEventListener('click', function (ereignis) {
      if (ereignis.defaultPrevented || !ereignis.isTrusted) return;
      var badge = ereignis.target.closest && ereignis.target.closest(BADGE_KAUFBOX);
      if (!badge || !badge.hasAttribute(BADGE_MARKE)) return;
      var widget = widgetFuerBadge(badge);
      if (!widget) return;
      ereignis.preventDefault();
      zumWidgetSpringen(widget);
    });

    document.addEventListener('keydown', function (ereignis) {
      if (ereignis.defaultPrevented || (ereignis.key !== 'Enter' && ereignis.key !== ' ')) return;
      var sterne = ereignis.target.closest && ereignis.target.closest('.jdgm-prev-badge__stars');
      var badge = sterne && sterne.closest(BADGE_KAUFBOX);
      if (!badge || !badge.hasAttribute(BADGE_MARKE)) return;
      var widget = widgetFuerBadge(badge);
      if (!widget) return;
      /* Verhindert bei der Leertaste auch das Seitenblättern. */
      ereignis.preventDefault();
      zumWidgetSpringen(widget);
    });

    document.addEventListener('click', function (ereignis) {
      var link = farbpunktAus(ereignis);
      if (!link || !einfacherKlick(ereignis)) return;

      var url = link.getAttribute('href');
      if (!url) return;

      /* Klick auf die bereits angezeigte Farbe: nichts tun, aber auch nicht neu laden. */
      if (url.split('?')[0] === window.location.pathname) {
        ereignis.preventDefault();
        return;
      }

      ereignis.preventDefault();
      wechseln(url, sid, true);
    });

    /* Zurück und Vorwärts im Browser sollen zwischen den Farben wechseln statt die
       Seite zu verlassen. Die Adresse hat der Browser bereits gesetzt; wir stellen
       nur den passenden Inhalt her. Ist das Ziel keine Farbe dieser Familie,
       überlassen wir es dem Browser. */
    window.addEventListener('popstate', function () {
      var pfad = window.location.pathname;
      var bekannt = Array.from(document.querySelectorAll('.crossseller-wrapper a[href]')).some(function (a) {
        return a.getAttribute('href').split('?')[0] === pfad;
      });
      /* … oder eine Grösse der Pseudo-Grössenwahl (URLs stehen im JSON des Snippets).
         Parsen statt Textsuche: Shopifys json-Filter schreibt den Schrägstrich mit
         Backslash davor, eine Textsuche nach dem Pfad findet ihn deshalb nie. */
      if (!bekannt) {
        var groessen = document.querySelector('.wb-groessen-wahl [data-wb-groessen]');
        try {
          bekannt = !!groessen && JSON.parse(groessen.textContent).some(function (e) {
            return e.url && e.url.split('?')[0] === pfad;
          });
        } catch (e) {
          bekannt = false;
        }
      }
      if (!bekannt) return;
      wechseln(pfad, sid, false);
    });
  }

  function tooltipsStarten() {
    tooltipsAusrichten();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(tooltipsAusrichten);
    window.addEventListener('resize', tooltipsSpaeterAusrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      tooltipsStarten();
      start();
    });
  } else {
    tooltipsStarten();
    start();
  }
})();
